<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>嘉兴侧钢箱梁</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <!-- <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div> -->
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">绍兴</span>
        </div>
        <div class="cable-img">
          <div class="tower-name tower-name-z3">Z3</div>
          <div class="tower-name tower-name-z4">Z4</div>
          <div class="tower-name tower-name-z5">Z5</div>

          <el-tooltip class="station-block station-block-g1g2" content="Z3B5钢箱梁G1/G2除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/gasclampStation/station19"></router-link>
          </el-tooltip>
          <div class="stati sta-g1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z3B5-L钢箱梁G1除湿机",
                    humidityTooltipErrorDehumidifierZ3B5LSteelBoxG1,
                    humidityAllowedMaxDehumidifierZ3B5LSteelBoxG1,
                    runningDehumidifierZ3B5LSteelBoxG1,
                    malfunctionDehumidifierZ3B5LSteelBoxG1
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("NBK1-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentNBK1L,
                    humidityAllowedMaxSteelBoxEnvironmentNBK1L)
                }}
                <br />
                {{
                  assembleTooltip_sensor(
                    "Z3B11-L梁段循环风",
                    humidityTooltipErrorSteelBoxEnvironmentZ3B11L,
                    humidityAllowedMaxSteelBoxEnvironmentZ3B11L
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z3B1-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ3B1L,
                    humidityAllowedMaxSteelBoxEnvironmentZ3B1L)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z3Z3-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ3Z3R,
                    humidityAllowedMaxSteelBoxEnvironmentZ3Z3R)
                }}
              </div>
              <div :class="errorZ3B5LSteelBoxG1" class="state-info right-pos" @dblclick="hrefToScenario('5396fee0-6842-4712-a68d-3504261c0189')"
                v-loading="stationNameLoadingDict['stationG1']">
                <p>
                  <span class="bold">Z3B5-L钢箱梁G1</span>
                  <span :class="runningClassZ3B5LSteelBoxG1" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ3B5LSteelBoxG1 | toFixed }}% {{ temperatureDehumidifierZ3B5LSteelBoxG1 |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>NBK1-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentNBK1L | toFixed }}% {{ temperatureSteelBoxEnvironmentNBK1L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z3B11-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ3B11L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ3B11L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z3B1-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ3B1L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ3B1L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z3Z3-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ3Z3R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ3Z3R |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-g2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z3B5-R钢箱梁G2除湿机",
                    humidityTooltipErrorDehumidifierZ3B5RSteelBoxG2,
                    humidityAllowedMaxDehumidifierZ3B5RSteelBoxG2,
                    runningDehumidifierZ3B5RSteelBoxG2,
                    malfunctionDehumidifierZ3B5RSteelBoxG2
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("NBK1-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentNBK1R,
                    humidityAllowedMaxSteelBoxEnvironmentNBK1R)
                }}
                <br />
                {{
                  assembleTooltip_sensor(
                    "Z3B11-R梁段循环风",
                    humidityTooltipErrorSteelBoxEnvironmentZ3B11R,
                    humidityAllowedMaxSteelBoxEnvironmentZ3B11R
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z3B1-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ3B1R,
                    humidityAllowedMaxSteelBoxEnvironmentZ3B1R)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z3Z3-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ3Z3L,
                    humidityAllowedMaxSteelBoxEnvironmentZ3Z3L)
                }}
              </div>
              <div :class="errorZ3B5RSteelBoxG2" class="state-info right-pos" @dblclick="hrefToScenario('f2766f78-e229-4675-b3a8-75026d5641c8')"
                v-loading="stationNameLoadingDict['stationG2']">
                <p>
                  <span class="bold">Z3B5-R钢箱梁G2</span>
                  <span :class="runningClassZ3B5RSteelBoxG2" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ3B5RSteelBoxG2 | toFixed }}% {{ temperatureDehumidifierZ3B5RSteelBoxG2 |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>NBK1-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentNBK1R | toFixed }}% {{ temperatureSteelBoxEnvironmentNBK1R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z3B11-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ3B11R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ3B11R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z3B1-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ3B1R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ3B1R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z3Z3-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ3Z3L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ3Z3L |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-g3g4" content="Z4B11钢箱梁G3/G4除湿机" effect="light"
            placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/gasclampStation/station20"></router-link>
          </el-tooltip>
          <div class="stati sta-g3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z4B11-L钢箱梁G3除湿机",
                    humidityTooltipErrorDehumidifierZ4B11LSteelBoxG3,
                    humidityAllowedMaxDehumidifierZ4B11LSteelBoxG3,
                    runningDehumidifierZ4B11LSteelBoxG3,
                    malfunctionDehumidifierZ4B11LSteelBoxG3
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z3Z4-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ3Z4R,
                    humidityAllowedMaxSteelBoxEnvironmentZ3Z4R)
                }}
                <br />
                {{
                  assembleTooltip_sensor(
                    "Z3Z11-R梁段循环风",
                    humidityTooltipErrorSteelBoxEnvironmentZ3Z11R,
                    humidityAllowedMaxSteelBoxEnvironmentZ3Z11R
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z4B7-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ4B7L,
                    humidityAllowedMaxSteelBoxEnvironmentZ4B7L)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z4B2-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ4B2L,
                    humidityAllowedMaxSteelBoxEnvironmentZ4B2L)
                }}
              </div>
              <div :class="errorZ4B11LSteelBoxG3" class="state-info bottom-pos" @dblclick="hrefToScenario('eb9059d0-6fed-4146-bd38-b76e8b1f142f')"
                v-loading="stationNameLoadingDict['stationG3']">
                <p>
                  <span class="bold">Z4B11-L钢箱梁G3</span>
                  <span :class="runningClassZ4B11LSteelBoxG3" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ4B11LSteelBoxG3 | toFixed }}% {{ temperatureDehumidifierZ4B11LSteelBoxG3
                    | toFixed }}°C</span>
                </p>
                <p>
                  <span>Z3Z4-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ3Z4R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ3Z4R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z3Z11-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ3Z11R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ3Z11R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z4B7-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ4B7L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ4B7L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z4B2-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ4B2L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ4B2L |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-g4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z4B11-R钢箱梁G4除湿机",
                    humidityTooltipErrorDehumidifierZ4B11RSteelBoxG4,
                    humidityAllowedMaxDehumidifierZ4B11RSteelBoxG4,
                    runningDehumidifierZ4B11RSteelBoxG4,
                    malfunctionDehumidifierZ4B11RSteelBoxG4
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z3Z4-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ3Z4L,
                    humidityAllowedMaxSteelBoxEnvironmentZ3Z4L)
                }}
                <br />
                {{
                  assembleTooltip_sensor(
                    "Z3Z11-L梁段循环风",
                    humidityTooltipErrorSteelBoxEnvironmentZ3Z11L,
                    humidityAllowedMaxSteelBoxEnvironmentZ3Z11L
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z4B7-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ4B7R,
                    humidityAllowedMaxSteelBoxEnvironmentZ4B7R)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z4B2-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ4B2R,
                    humidityAllowedMaxSteelBoxEnvironmentZ4B2R)
                }}
              </div>
              <div :class="errorZ4B11RSteelBoxG4" class="state-info top-pos" @dblclick="hrefToScenario('b5034eeb-30be-4979-939e-53e3fa160a7c')"
                v-loading="stationNameLoadingDict['stationG4']">
                <p>
                  <span class="bold">Z4B11-R钢箱梁G4</span>
                  <span :class="runningClassZ4B11RSteelBoxG4" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ4B11RSteelBoxG4 | toFixed }}% {{ temperatureDehumidifierZ4B11RSteelBoxG4
                    | toFixed }}°C</span>
                </p>
                <p>
                  <span>Z3Z4-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ3Z4L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ3Z4L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z3Z11-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ3Z11L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ3Z11L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z4B7-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ4B7R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ4B7R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z4B2-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ4B2R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ4B2R |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-g5g6" content="Z4Z8钢箱梁G5/G6除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/gasclampStation/station21"></router-link>
          </el-tooltip>
          <div class="stati sta-g6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z4Z8-L钢箱梁G6除湿机",
                    humidityTooltipErrorDehumidifierZ4Z8LSteelBoxG6,
                    humidityAllowedMaxDehumidifierZ4Z8LSteelBoxG6,
                    runningDehumidifierZ4Z8LSteelBoxG6,
                    malfunctionDehumidifierZ4Z8LSteelBoxG6
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z4B1-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ4B1R,
                    humidityAllowedMaxSteelBoxEnvironmentZ4B1R)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z4Z2-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ4Z2L,
                    humidityAllowedMaxSteelBoxEnvironmentZ4Z2L)
                }}
                <br />
                {{
                  assembleTooltip_sensor(
                    "Z4Z12-L梁段循环风",
                    humidityTooltipErrorSteelBoxEnvironmentZ4Z12L,
                    humidityAllowedMaxSteelBoxEnvironmentZ4Z12L
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z5B7-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ5B7R,
                    humidityAllowedMaxSteelBoxEnvironmentZ5B7R)
                }}
              </div>
              <div :class="errorZ4Z8LSteelBoxG6" class="state-info top-pos" @dblclick="hrefToScenario('6f6ed5be-7474-403d-aa47-22fbb4e3af67')"
                v-loading="stationNameLoadingDict['stationG6']">
                <p>
                  <span class="bold">Z4Z8-L钢箱梁G6</span>
                  <span :class="runningClassZ4Z8LSteelBoxG6" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ4Z8LSteelBoxG6 | toFixed }}% {{ temperatureDehumidifierZ4Z8LSteelBoxG6 |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z4B1-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ4B1R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ4B1R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z4Z2-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ4Z2L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ4Z2L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z4Z12-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ4Z12L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ4Z12L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z5B7-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ5B7R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ5B7R |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-g5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z4Z8-R钢箱梁G5除湿机",
                    humidityTooltipErrorDehumidifierZ4Z8RSteelBoxG5,
                    humidityAllowedMaxDehumidifierZ4Z8RSteelBoxG5,
                    runningDehumidifierZ4Z8RSteelBoxG5,
                    malfunctionDehumidifierZ4Z8RSteelBoxG5
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z4B1-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ4B1L,
                    humidityAllowedMaxSteelBoxEnvironmentZ4B1L)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z4Z2-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ4Z2R,
                    humidityAllowedMaxSteelBoxEnvironmentZ4Z2R)
                }}
                <br />
                {{
                  assembleTooltip_sensor(
                    "Z4Z12-R梁段循环风",
                    humidityTooltipErrorSteelBoxEnvironmentZ4Z12R,
                    humidityAllowedMaxSteelBoxEnvironmentZ4Z12R
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z5B7-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ5B7L,
                    humidityAllowedMaxSteelBoxEnvironmentZ5B7L)
                }}
              </div>
              <div :class="errorZ4Z8RSteelBoxG5" class="state-info bottom-pos" @dblclick="hrefToScenario('6b1964e2-88d1-4418-897a-06469fb4d46f')"
                v-loading="stationNameLoadingDict['stationG5']">
                <p>
                  <span class="bold">Z4Z8-R钢箱梁G5</span>
                  <span :class="runningClassZ4Z8RSteelBoxG5" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ4Z8RSteelBoxG5 | toFixed }}% {{ temperatureDehumidifierZ4Z8RSteelBoxG5 |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z4B1-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ4B1L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ4B1L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z4Z2-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ4Z2R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ4Z2R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z4Z12-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ4Z12R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ4Z12R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z5B7-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ5B7L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ5B7L |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-g7g8" content="Z5Z1钢箱梁G7/G8除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/gasclampStation/station15"></router-link>
          </el-tooltip>
          <div class="stati sta-g8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z5Z1-L钢箱梁G8除湿机",
                    humidityTooltipErrorDehumidifierZ5Z1LSteelBoxG8,
                    humidityAllowedMaxDehumidifierZ5Z1LSteelBoxG8,
                    runningDehumidifierZ5Z1LSteelBoxG8,
                    malfunctionDehumidifierZ5Z1LSteelBoxG8
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z5B6-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ5B6R,
                    humidityAllowedMaxSteelBoxEnvironmentZ5B6R)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z5B1-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ5B1R,
                    humidityAllowedMaxSteelBoxEnvironmentZ5B1R)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z5Z6-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ5Z6L,
                    humidityAllowedMaxSteelBoxEnvironmentZ5Z6L)
                }}
                <br />
                {{ assembleTooltip_sensor("J3-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentJ3L,
                  humidityAllowedMaxSteelBoxEnvironmentJ3L) }}
              </div>
              <div :class="errorZ5Z1LSteelBoxG8" class="state-info left-pos" @dblclick="hrefToScenario('f42739a3-edbf-43b8-b72d-1a21c2d80076')"
                v-loading="stationNameLoadingDict['stationG8']">
                <p>
                  <span class="bold">Z5Z1-L钢箱梁G8</span>
                  <span :class="runningClassZ5Z1LSteelBoxG8" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ5Z1LSteelBoxG8 | toFixed }}% {{ temperatureDehumidifierZ5Z1LSteelBoxG8 |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z5B6-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ5B6R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ5B6R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z5B1-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ5B1R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ5B1R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z5Z6-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ5Z6L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ5Z6L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>J3-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentJ3L | toFixed }}% {{ temperatureSteelBoxEnvironmentJ3L | toFixed
                  }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-g7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z5Z1-R钢箱梁G7除湿机",
                    humidityTooltipErrorDehumidifierZ5Z1RSteelBoxG7,
                    humidityAllowedMaxDehumidifierZ5Z1RSteelBoxG7,
                    runningDehumidifierZ5Z1RSteelBoxG7,
                    malfunctionDehumidifierZ5Z1RSteelBoxG7
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z5B6-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ5B6L,
                    humidityAllowedMaxSteelBoxEnvironmentZ5B6L)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z5B1-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ5B1L,
                    humidityAllowedMaxSteelBoxEnvironmentZ5B1L)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z5Z6-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ5Z6R,
                    humidityAllowedMaxSteelBoxEnvironmentZ5Z6R)
                }}
                <br />
                {{ assembleTooltip_sensor("J3-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentJ3R,
                  humidityAllowedMaxSteelBoxEnvironmentJ3R) }}
              </div>
              <div :class="errorZ5Z1RSteelBoxG7" class="state-info left-pos" @dblclick="hrefToScenario('7fe9d757-21e9-4827-b80a-f5f896b23384')"
                v-loading="stationNameLoadingDict['stationG7']">
                <p>
                  <span class="bold">Z5Z1-R钢箱梁G7</span>
                  <span :class="runningClassZ5Z1RSteelBoxG7" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ5Z1RSteelBoxG7 | toFixed }}% {{ temperatureDehumidifierZ5Z1RSteelBoxG7 |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z5B6-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ5B6L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ5B6L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z5B1-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ5B1L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ5B1L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z5Z6-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ5Z6R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ5Z6R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>J3-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentJ3R | toFixed }}% {{ temperatureSteelBoxEnvironmentJ3R | toFixed
                  }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>绍兴侧钢箱梁</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <!-- <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div> -->
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">绍兴</span>
        </div>
        <div class="cable-img image-reversed">
          <div class="tower-name tower-name-z6">Z6</div>
          <div class="tower-name tower-name-z7">Z7</div>
          <div class="tower-name tower-name-z8">Z8</div>

          <el-tooltip class="station-block station-block-g9g10" content="Z6Z1钢箱梁G9/G10除湿机" effect="light"
            placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/gasclampStation/station31"></router-link>
          </el-tooltip>
          <div class="stati sta-g9">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z6Z1-L钢箱梁G9除湿机",
                    humidityTooltipErrorDehumidifierZ6Z1LSteelBoxG9,
                    humidityAllowedMaxDehumidifierZ6Z1LSteelBoxG9,
                    runningDehumidifierZ6Z1LSteelBoxG9,
                    malfunctionDehumidifierZ6Z1LSteelBoxG9
                  )
                }}
                <br />
                {{ assembleTooltip_sensor("J1-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentJ1L,
                  humidityAllowedMaxSteelBoxEnvironmentJ1L) }}
                <br />
                {{
                  assembleTooltip_sensor("Z6Z6-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ6Z6L,
                    humidityAllowedMaxSteelBoxEnvironmentZ6Z6L)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z6B1-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ6B1R,
                    humidityAllowedMaxSteelBoxEnvironmentZ6B1R)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z6B6-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ6B6R,
                    humidityAllowedMaxSteelBoxEnvironmentZ6B6R)
                }}
              </div>
              <div :class="errorZ6Z1LSteelBoxG9" class="state-info right-pos" @dblclick="hrefToScenario('8b5c9081-c5c1-4fc8-8d6d-c18eca2a65cb')"
                v-loading="stationNameLoadingDict['stationG9']">
                <p>
                  <span class="bold">Z6Z1-L钢箱梁G9</span>
                  <span :class="runningClassZ6Z1LSteelBoxG9" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ6Z1LSteelBoxG9 | toFixed }}% {{ temperatureDehumidifierZ6Z1LSteelBoxG9 |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>J1-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentJ1L | toFixed }}% {{ temperatureSteelBoxEnvironmentJ1L | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>Z6Z6-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ6Z6L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ6Z6L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z6B1-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ6B1R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ6B1R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z6B6-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ6B6R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ6B6R |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-g10">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z6Z1-R钢箱梁G10除湿机",
                    humidityTooltipErrorDehumidifierZ6Z1RSteelBoxG10,
                    humidityAllowedMaxDehumidifierZ6Z1RSteelBoxG10,
                    runningDehumidifierZ6Z1RSteelBoxG10,
                    malfunctionDehumidifierZ6Z1RSteelBoxG10
                  )
                }}
                <br />
                {{ assembleTooltip_sensor("J1-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentJ1R,
                  humidityAllowedMaxSteelBoxEnvironmentJ1R) }}
                <br />
                {{
                  assembleTooltip_sensor("Z6Z6-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ6Z6R,
                    humidityAllowedMaxSteelBoxEnvironmentZ6Z6R)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z6B1-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ6B1L,
                    humidityAllowedMaxSteelBoxEnvironmentZ6B1L)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z6B6-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ6B6L,
                    humidityAllowedMaxSteelBoxEnvironmentZ6B6L)
                }}
              </div>
              <div :class="errorZ6Z1RSteelBoxG10" class="state-info right-pos" @dblclick="hrefToScenario('37913c69-ff69-496b-8595-42e8425142c6')"
                v-loading="stationNameLoadingDict['stationG10']">
                <p>
                  <span class="bold">Z6Z1-R钢箱梁G10</span>
                  <span :class="runningClassZ6Z1RSteelBoxG10" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ6Z1RSteelBoxG10 | toFixed }}% {{ temperatureDehumidifierZ6Z1RSteelBoxG10
                    | toFixed }}°C</span>
                </p>
                <p>
                  <span>J1-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentJ1R | toFixed }}% {{ temperatureSteelBoxEnvironmentJ1R | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>Z6Z6-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ6Z6R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ6Z6R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z6B1-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ6B1L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ6B1L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z6B6-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ6B6L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ6B6L |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-g11g12" content="Z7Z8钢箱梁G11/G12除湿机" effect="light"
            placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/gasclampStation/station30"></router-link>
          </el-tooltip>
          <div class="stati sta-g11">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z7Z8-L钢箱梁G11除湿机",
                    humidityTooltipErrorDehumidifierZ7Z8LSteelBoxG11,
                    humidityAllowedMaxDehumidifierZ7Z8LSteelBoxG11,
                    runningDehumidifierZ7Z8LSteelBoxG11,
                    malfunctionDehumidifierZ7Z8LSteelBoxG11
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z6B7-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ6B7R,
                    humidityAllowedMaxSteelBoxEnvironmentZ6B7R)
                }}
                <br />
                {{
                  assembleTooltip_sensor(
                    "Z6B12-R梁段循环风",
                    humidityTooltipErrorSteelBoxEnvironmentZ6B12R,
                    humidityAllowedMaxSteelBoxEnvironmentZ6B12R
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z7Z2-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ7Z2L,
                    humidityAllowedMaxSteelBoxEnvironmentZ7Z2L)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z7B1-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ7B1R,
                    humidityAllowedMaxSteelBoxEnvironmentZ7B1R)
                }}
              </div>
              <div :class="errorZ7Z8LSteelBoxG11" class="state-info bottom-pos" @dblclick="hrefToScenario('218d14eb-6c4e-450a-949a-95f7705c20f8')"
                v-loading="stationNameLoadingDict['stationG11']">
                <p>
                  <span class="bold">Z7Z8-L钢箱梁G11</span>
                  <span :class="runningClassZ7Z8LSteelBoxG11" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ7Z8LSteelBoxG11 | toFixed }}% {{ temperatureDehumidifierZ7Z8LSteelBoxG11
                    | toFixed }}°C</span>
                </p>
                <p>
                  <span>Z6B7-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ6B7R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ6B7R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z6B12-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ6B12R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ6B12R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z7Z2-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ7Z2L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ7Z2L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z7B1-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ7B1R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ7B1R |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-g12">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z7Z8-R钢箱梁G12除湿机",
                    humidityTooltipErrorDehumidifierZ7Z8RSteelBoxG12,
                    humidityAllowedMaxDehumidifierZ7Z8RSteelBoxG12,
                    runningDehumidifierZ7Z8RSteelBoxG12,
                    malfunctionDehumidifierZ7Z8RSteelBoxG12
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z6B7-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ6B7L,
                    humidityAllowedMaxSteelBoxEnvironmentZ6B7L)
                }}
                <br />
                {{
                  assembleTooltip_sensor(
                    "Z6B12-L梁段循环风",
                    humidityTooltipErrorSteelBoxEnvironmentZ6B12L,
                    humidityAllowedMaxSteelBoxEnvironmentZ6B12L
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z7Z2-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ7Z2R,
                    humidityAllowedMaxSteelBoxEnvironmentZ7Z2R)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z7B1-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ7B1L,
                    humidityAllowedMaxSteelBoxEnvironmentZ7B1L)
                }}
              </div>
              <div :class="errorZ7Z8RSteelBoxG12" class="state-info top-pos" @dblclick="hrefToScenario('f16a9fba-0b3f-4c5e-9753-d2b58082fbf2')"
                v-loading="stationNameLoadingDict['stationG12']">
                <p>
                  <span class="bold">Z7Z8-R钢箱梁G12</span>
                  <span :class="runningClassZ7Z8RSteelBoxG12" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ7Z8RSteelBoxG12 | toFixed }}% {{ temperatureDehumidifierZ7Z8RSteelBoxG12
                    | toFixed }}°C</span>
                </p>
                <p>
                  <span>Z6B7-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ6B7L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ6B7L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z6B12-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ6B12L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ6B12L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z7Z2-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ7Z2R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ7Z2R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z7B1-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ7B1L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ7B1L |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-g13g14" content="Z7B11钢箱梁G13/G14除湿机" effect="light"
            placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/gasclampStation/station11"></router-link>
          </el-tooltip>
          <div class="stati sta-g14">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z7B11-L钢箱梁G14除湿机",
                    humidityTooltipErrorDehumidifierZ7B11LSteelBoxG14,
                    humidityAllowedMaxDehumidifierZ7B11LSteelBoxG14,
                    runningDehumidifierZ7B11LSteelBoxG14,
                    malfunctionDehumidifierZ7B11LSteelBoxG14
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z7B2-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ7B2L,
                    humidityAllowedMaxSteelBoxEnvironmentZ7B2L)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z7B7-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ7B7L,
                    humidityAllowedMaxSteelBoxEnvironmentZ7B7L)
                }}
                <br />
                {{
                  assembleTooltip_sensor(
                    "Z8Z10-R梁段循环风",
                    humidityTooltipErrorSteelBoxEnvironmentZ8Z10R,
                    humidityAllowedMaxSteelBoxEnvironmentZ8Z10R
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z8B4-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ8B4R,
                    humidityAllowedMaxSteelBoxEnvironmentZ8B4R)
                }}
              </div>
              <div :class="errorZ7B11LSteelBoxG14" class="state-info top-pos" @dblclick="hrefToScenario('9734e754-8601-4e81-8445-54bb12640df6')"
                v-loading="stationNameLoadingDict['stationG14']">
                <p>
                  <span class="bold">Z7B11-L钢箱梁G14</span>
                  <span :class="runningClassZ7B11LSteelBoxG14" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ7B11LSteelBoxG14 | toFixed }}% {{
                    temperatureDehumidifierZ7B11LSteelBoxG14 | toFixed }}°C</span>
                </p>
                <p>
                  <span>Z7B2-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ7B2L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ7B2L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z7B7-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ7B7L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ7B7L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z8Z10-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ8Z10R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ8Z10R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z8B4-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ8B4R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ8B4R |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-g13">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z7B11-R钢箱梁G13除湿机",
                    humidityTooltipErrorDehumidifierZ7B11RSteelBoxG13,
                    humidityAllowedMaxDehumidifierZ7B11RSteelBoxG13,
                    runningDehumidifierZ7B11RSteelBoxG13,
                    malfunctionDehumidifierZ7B11RSteelBoxG13
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z7B2-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ7B2R,
                    humidityAllowedMaxSteelBoxEnvironmentZ7B2R)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z7B7-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ7B7R,
                    humidityAllowedMaxSteelBoxEnvironmentZ7B7R)
                }}
                <br />
                {{
                  assembleTooltip_sensor(
                    "Z8Z10-L梁段循环风",
                    humidityTooltipErrorSteelBoxEnvironmentZ8Z10L,
                    humidityAllowedMaxSteelBoxEnvironmentZ8Z10L
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z8B4-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ8B4L,
                    humidityAllowedMaxSteelBoxEnvironmentZ8B4L)
                }}
              </div>
              <div :class="errorZ7B11RSteelBoxG13" class="state-info bottom-pos" @dblclick="hrefToScenario('4a35b34a-95a6-43fb-b6bc-2212c9b27b27')"
                v-loading="stationNameLoadingDict['stationG13']">
                <p>
                  <span class="bold">Z7B11-R钢箱梁G13</span>
                  <span :class="runningClassZ7B11RSteelBoxG13" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ7B11RSteelBoxG13 | toFixed }}% {{
                    temperatureDehumidifierZ7B11RSteelBoxG13 | toFixed }}°C</span>
                </p>
                <p>
                  <span>Z7B2-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ7B2R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ7B2R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z7B7-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ7B7R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ7B7R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z8Z10-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ8Z10L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ8Z10L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z8B4-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ8B4L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ8B4L |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-g15g16" content="Z8B5钢箱梁G15/G16除湿机" effect="light"
            placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/gasclampStation/station28"></router-link>
          </el-tooltip>
          <div class="stati sta-g16">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z8B5-L钢箱梁G16除湿机",
                    humidityTooltipErrorDehumidifierZ8B5LSteelBoxG16,
                    humidityAllowedMaxDehumidifierZ8B5LSteelBoxG16,
                    runningDehumidifierZ8B5LSteelBoxG16,
                    malfunctionDehumidifierZ8B5LSteelBoxG16
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z8Z3-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ8Z3R,
                    humidityAllowedMaxSteelBoxEnvironmentZ8Z3R)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z8B1-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ8B1L,
                    humidityAllowedMaxSteelBoxEnvironmentZ8B1L)
                }}
                <br />
                {{
                  assembleTooltip_sensor(
                    "Z8B11-L梁段循环风",
                    humidityTooltipErrorSteelBoxEnvironmentZ8B11L,
                    humidityAllowedMaxSteelBoxEnvironmentZ8B11L
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("SBK1-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentSBK1L,
                    humidityAllowedMaxSteelBoxEnvironmentSBK1L)
                }}
              </div>
              <div :class="errorZ8B5LSteelBoxG16" class="state-info left-pos" @dblclick="hrefToScenario('4359f316-e94c-4e7c-b948-9181008a50a5')"
                v-loading="stationNameLoadingDict['stationG16']">
                <p>
                  <span class="bold">Z8B5-L钢箱梁G16</span>
                  <span :class="runningClassZ8B5LSteelBoxG16" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ8B5LSteelBoxG16 | toFixed }}% {{ temperatureDehumidifierZ8B5LSteelBoxG16
                    | toFixed }}°C</span>
                </p>
                <p>
                  <span>Z8Z3-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ8Z3R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ8Z3R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z8B1-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ8B1L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ8B1L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z8B11-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ8B11L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ8B11L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>SBK1-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentSBK1L | toFixed }}% {{ temperatureSteelBoxEnvironmentSBK1L |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-g15">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z8B5-R钢箱梁G15除湿机",
                    humidityTooltipErrorDehumidifierZ8B5RSteelBoxG15,
                    humidityAllowedMaxDehumidifierZ8B5RSteelBoxG15,
                    runningDehumidifierZ8B5RSteelBoxG15,
                    malfunctionDehumidifierZ8B5RSteelBoxG15
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z8Z3-L梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ8Z3L,
                    humidityAllowedMaxSteelBoxEnvironmentZ8Z3L)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z8B1-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentZ8B1R,
                    humidityAllowedMaxSteelBoxEnvironmentZ8B1R)
                }}
                <br />
                {{
                  assembleTooltip_sensor(
                    "Z8B11-R梁段循环风",
                    humidityTooltipErrorSteelBoxEnvironmentZ8B11R,
                    humidityAllowedMaxSteelBoxEnvironmentZ8B11R
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("SBK1-R梁段循环风", humidityTooltipErrorSteelBoxEnvironmentSBK1R,
                    humidityAllowedMaxSteelBoxEnvironmentSBK1R)
                }}
              </div>
              <div :class="errorZ8B5RSteelBoxG15" class="state-info left-pos" @dblclick="hrefToScenario('ce3af0d0-21cf-40bc-b927-627d31a0a33b')"
                v-loading="stationNameLoadingDict['stationG15']">
                <p>
                  <span class="bold">Z8B5-R钢箱梁G15</span>
                  <span :class="runningClassZ8B5RSteelBoxG15" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ8B5RSteelBoxG15 | toFixed }}% {{ temperatureDehumidifierZ8B5RSteelBoxG15
                    | toFixed }}°C</span>
                </p>
                <p>
                  <span>Z8Z3-L梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ8Z3L | toFixed }}% {{ temperatureSteelBoxEnvironmentZ8Z3L |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z8B1-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ8B1R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ8B1R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>Z8B11-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentZ8B11R | toFixed }}% {{ temperatureSteelBoxEnvironmentZ8B11R |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>SBK1-R梁段</span>
                  <span>{{ humiditySteelBoxEnvironmentSBK1R | toFixed }}% {{ temperatureSteelBoxEnvironmentSBK1R |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      routerPrefix: "jiashao",
      bridgeId: "3b04991c-3662-4948-930e-ac537ed82fd3",

      //humidity, temperature, pressure, flow, volume
      //humidity, temperature
      humidityDehumidifierZ3TowerTop: "--",
      humidityDehumidifierZ3TowerMid: "--",
      humidityDehumidifierZ4TowerTop: "--",
      humidityDehumidifierZ4TowerMid: "--",
      humidityDehumidifierZ5TowerTop: "--",
      humidityDehumidifierZ5TowerMid: "--",
      humidityDehumidifierZ6TowerTop: "--",
      humidityDehumidifierZ6TowerMid: "--",
      humidityDehumidifierZ7TowerTop: "--",
      humidityDehumidifierZ7TowerMid: "--",
      humidityDehumidifierZ8TowerTop: "--",
      humidityDehumidifierZ8TowerMid: "--",

      humidityDehumidifierZ3B5LSteelBoxG1: "--",
      humidityDehumidifierZ3B5RSteelBoxG2: "--",
      humidityDehumidifierZ4B11LSteelBoxG3: "--",
      humidityDehumidifierZ4B11RSteelBoxG4: "--",
      humidityDehumidifierZ4Z8RSteelBoxG5: "--",
      humidityDehumidifierZ4Z8LSteelBoxG6: "--",
      humidityDehumidifierZ5Z1RSteelBoxG7: "--",
      humidityDehumidifierZ5Z1LSteelBoxG8: "--",
      humidityDehumidifierZ6Z1LSteelBoxG9: "--",
      humidityDehumidifierZ6Z1RSteelBoxG10: "--",
      humidityDehumidifierZ7Z8LSteelBoxG11: "--",
      humidityDehumidifierZ7Z8RSteelBoxG12: "--",
      humidityDehumidifierZ7B11RSteelBoxG13: "--",
      humidityDehumidifierZ7B11LSteelBoxG14: "--",
      humidityDehumidifierZ8B5RSteelBoxG15: "--",
      humidityDehumidifierZ8B5LSteelBoxG16: "--",

      temperatureDehumidifierZ3TowerTop: "--",
      temperatureDehumidifierZ3TowerMid: "--",
      temperatureDehumidifierZ4TowerTop: "--",
      temperatureDehumidifierZ4TowerMid: "--",
      temperatureDehumidifierZ5TowerTop: "--",
      temperatureDehumidifierZ5TowerMid: "--",
      temperatureDehumidifierZ6TowerTop: "--",
      temperatureDehumidifierZ6TowerMid: "--",
      temperatureDehumidifierZ7TowerTop: "--",
      temperatureDehumidifierZ7TowerMid: "--",
      temperatureDehumidifierZ8TowerTop: "--",
      temperatureDehumidifierZ8TowerMid: "--",

      temperatureDehumidifierZ3B5LSteelBoxG1: "--",
      temperatureDehumidifierZ3B5RSteelBoxG2: "--",
      temperatureDehumidifierZ4B11LSteelBoxG3: "--",
      temperatureDehumidifierZ4B11RSteelBoxG4: "--",
      temperatureDehumidifierZ4Z8RSteelBoxG5: "--",
      temperatureDehumidifierZ4Z8LSteelBoxG6: "--",
      temperatureDehumidifierZ5Z1RSteelBoxG7: "--",
      temperatureDehumidifierZ5Z1LSteelBoxG8: "--",
      temperatureDehumidifierZ6Z1LSteelBoxG9: "--",
      temperatureDehumidifierZ6Z1RSteelBoxG10: "--",
      temperatureDehumidifierZ7Z8LSteelBoxG11: "--",
      temperatureDehumidifierZ7Z8RSteelBoxG12: "--",
      temperatureDehumidifierZ7B11RSteelBoxG13: "--",
      temperatureDehumidifierZ7B11LSteelBoxG14: "--",
      temperatureDehumidifierZ8B5RSteelBoxG15: "--",
      temperatureDehumidifierZ8B5LSteelBoxG16: "--",

      humidityZ3TowerTopEnvironmentUp: "--",
      humidityZ3TowerTopEnvironmentMid: "--",
      humidityZ3TowerTopEnvironmentDown: "--",
      humidityZ3TowerMidEnvironmentUp: "--",
      humidityZ3TowerMidEnvironmentMid: "--",
      humidityZ3TowerMidEnvironmentDown: "--",
      humidityZ4TowerTopEnvironmentUp: "--",
      humidityZ4TowerTopEnvironmentMid: "--",
      humidityZ4TowerTopEnvironmentDown: "--",
      humidityZ4TowerMidEnvironmentUp: "--",
      humidityZ4TowerMidEnvironmentMid: "--",
      humidityZ4TowerMidEnvironmentDown: "--",
      humidityZ5TowerTopEnvironmentUp: "--",
      humidityZ5TowerTopEnvironmentMid: "--",
      humidityZ5TowerTopEnvironmentDown: "--",
      humidityZ5TowerMidEnvironmentUp: "--",
      humidityZ5TowerMidEnvironmentMid: "--",
      humidityZ5TowerMidEnvironmentDown: "--",
      humidityZ6TowerTopEnvironmentUp: "--",
      humidityZ6TowerTopEnvironmentMid: "--",
      humidityZ6TowerTopEnvironmentDown: "--",
      humidityZ6TowerMidEnvironmentUp: "--",
      humidityZ6TowerMidEnvironmentMid: "--",
      humidityZ6TowerMidEnvironmentDown: "--",
      humidityZ7TowerTopEnvironmentUp: "--",
      humidityZ7TowerTopEnvironmentMid: "--",
      humidityZ7TowerTopEnvironmentDown: "--",
      humidityZ7TowerMidEnvironmentUp: "--",
      humidityZ7TowerMidEnvironmentMid: "--",
      humidityZ7TowerMidEnvironmentDown: "--",
      humidityZ8TowerTopEnvironmentUp: "--",
      humidityZ8TowerTopEnvironmentMid: "--",
      humidityZ8TowerTopEnvironmentDown: "--",
      humidityZ8TowerMidEnvironmentUp: "--",
      humidityZ8TowerMidEnvironmentMid: "--",
      humidityZ8TowerMidEnvironmentDown: "--",

      humiditySteelBoxEnvironmentZ5B6R: "--",
      humiditySteelBoxEnvironmentZ5B1R: "--",
      humiditySteelBoxEnvironmentZ5Z6L: "--",
      humiditySteelBoxEnvironmentJ3L: "--",
      humiditySteelBoxEnvironmentZ4B1R: "--",
      humiditySteelBoxEnvironmentZ4Z2L: "--",
      humiditySteelBoxEnvironmentZ4Z12L: "--",
      humiditySteelBoxEnvironmentZ5B7R: "--",
      humiditySteelBoxEnvironmentZ5B6L: "--",
      humiditySteelBoxEnvironmentZ5B1L: "--",
      humiditySteelBoxEnvironmentZ5Z6R: "--",
      humiditySteelBoxEnvironmentJ3R: "--",
      humiditySteelBoxEnvironmentNBK1R: "--",
      humiditySteelBoxEnvironmentZ3B11R: "--",
      humiditySteelBoxEnvironmentZ3B1R: "--",
      humiditySteelBoxEnvironmentZ3Z3L: "--",
      humiditySteelBoxEnvironmentZ3Z4R: "--",
      humiditySteelBoxEnvironmentZ3Z11R: "--",
      humiditySteelBoxEnvironmentZ4B7L: "--",
      humiditySteelBoxEnvironmentZ4B2L: "--",
      humiditySteelBoxEnvironmentNBK1L: "--",
      humiditySteelBoxEnvironmentZ3B11L: "--",
      humiditySteelBoxEnvironmentZ3B1L: "--",
      humiditySteelBoxEnvironmentZ3Z3R: "--",
      humiditySteelBoxEnvironmentZ3Z4L: "--",
      humiditySteelBoxEnvironmentZ3Z11L: "--",
      humiditySteelBoxEnvironmentZ4B7R: "--",
      humiditySteelBoxEnvironmentZ4B2R: "--",
      humiditySteelBoxEnvironmentZ4B1L: "--",
      humiditySteelBoxEnvironmentZ4Z2R: "--",
      humiditySteelBoxEnvironmentZ4Z12R: "--",
      humiditySteelBoxEnvironmentZ5B7L: "--",
      humiditySteelBoxEnvironmentZ8Z3L: "--",
      humiditySteelBoxEnvironmentZ8B1R: "--",
      humiditySteelBoxEnvironmentZ8B11R: "--",
      humiditySteelBoxEnvironmentSBK1R: "--",
      humiditySteelBoxEnvironmentZ8Z3R: "--",
      humiditySteelBoxEnvironmentZ8B1L: "--",
      humiditySteelBoxEnvironmentZ8B11L: "--",
      humiditySteelBoxEnvironmentSBK1L: "--",
      humiditySteelBoxEnvironmentZ6B7R: "--",
      humiditySteelBoxEnvironmentZ6B12R: "--",
      humiditySteelBoxEnvironmentZ7Z2L: "--",
      humiditySteelBoxEnvironmentZ7B1R: "--",
      humiditySteelBoxEnvironmentZ6B7L: "--",
      humiditySteelBoxEnvironmentZ6B12L: "--",
      humiditySteelBoxEnvironmentZ7Z2R: "--",
      humiditySteelBoxEnvironmentZ7B1L: "--",
      humiditySteelBoxEnvironmentJ1L: "--",
      humiditySteelBoxEnvironmentZ6Z6L: "--",
      humiditySteelBoxEnvironmentZ6B1R: "--",
      humiditySteelBoxEnvironmentZ6B6R: "--",
      humiditySteelBoxEnvironmentJ1R: "--",
      humiditySteelBoxEnvironmentZ6Z6R: "--",
      humiditySteelBoxEnvironmentZ6B1L: "--",
      humiditySteelBoxEnvironmentZ6B6L: "--",
      humiditySteelBoxEnvironmentZ7B2L: "--",
      humiditySteelBoxEnvironmentZ7B7L: "--",
      humiditySteelBoxEnvironmentZ8Z10R: "--",
      humiditySteelBoxEnvironmentZ8B4R: "--",
      humiditySteelBoxEnvironmentZ7B2R: "--",
      humiditySteelBoxEnvironmentZ7B7R: "--",
      humiditySteelBoxEnvironmentZ8Z10L: "--",
      humiditySteelBoxEnvironmentZ8B4L: "--",

      temperatureZ3TowerTopEnvironmentUp: "--",
      temperatureZ3TowerTopEnvironmentMid: "--",
      temperatureZ3TowerTopEnvironmentDown: "--",
      temperatureZ3TowerMidEnvironmentUp: "--",
      temperatureZ3TowerMidEnvironmentMid: "--",
      temperatureZ3TowerMidEnvironmentDown: "--",
      temperatureZ4TowerTopEnvironmentUp: "--",
      temperatureZ4TowerTopEnvironmentMid: "--",
      temperatureZ4TowerTopEnvironmentDown: "--",
      temperatureZ4TowerMidEnvironmentUp: "--",
      temperatureZ4TowerMidEnvironmentMid: "--",
      temperatureZ4TowerMidEnvironmentDown: "--",
      temperatureZ5TowerTopEnvironmentUp: "--",
      temperatureZ5TowerTopEnvironmentMid: "--",
      temperatureZ5TowerTopEnvironmentDown: "--",
      temperatureZ5TowerMidEnvironmentUp: "--",
      temperatureZ5TowerMidEnvironmentMid: "--",
      temperatureZ5TowerMidEnvironmentDown: "--",
      temperatureZ6TowerTopEnvironmentUp: "--",
      temperatureZ6TowerTopEnvironmentMid: "--",
      temperatureZ6TowerTopEnvironmentDown: "--",
      temperatureZ6TowerMidEnvironmentUp: "--",
      temperatureZ6TowerMidEnvironmentMid: "--",
      temperatureZ6TowerMidEnvironmentDown: "--",
      temperatureZ7TowerTopEnvironmentUp: "--",
      temperatureZ7TowerTopEnvironmentMid: "--",
      temperatureZ7TowerTopEnvironmentDown: "--",
      temperatureZ7TowerMidEnvironmentUp: "--",
      temperatureZ7TowerMidEnvironmentMid: "--",
      temperatureZ7TowerMidEnvironmentDown: "--",
      temperatureZ8TowerTopEnvironmentUp: "--",
      temperatureZ8TowerTopEnvironmentMid: "--",
      temperatureZ8TowerTopEnvironmentDown: "--",
      temperatureZ8TowerMidEnvironmentUp: "--",
      temperatureZ8TowerMidEnvironmentMid: "--",
      temperatureZ8TowerMidEnvironmentDown: "--",

      temperatureSteelBoxEnvironmentZ5B6R: "--",
      temperatureSteelBoxEnvironmentZ5B1R: "--",
      temperatureSteelBoxEnvironmentZ5Z6L: "--",
      temperatureSteelBoxEnvironmentJ3L: "--",
      temperatureSteelBoxEnvironmentZ4B1R: "--",
      temperatureSteelBoxEnvironmentZ4Z2L: "--",
      temperatureSteelBoxEnvironmentZ4Z12L: "--",
      temperatureSteelBoxEnvironmentZ5B7R: "--",
      temperatureSteelBoxEnvironmentZ5B6L: "--",
      temperatureSteelBoxEnvironmentZ5B1L: "--",
      temperatureSteelBoxEnvironmentZ5Z6R: "--",
      temperatureSteelBoxEnvironmentJ3R: "--",
      temperatureSteelBoxEnvironmentNBK1R: "--",
      temperatureSteelBoxEnvironmentZ3B11R: "--",
      temperatureSteelBoxEnvironmentZ3B1R: "--",
      temperatureSteelBoxEnvironmentZ3Z3L: "--",
      temperatureSteelBoxEnvironmentZ3Z4R: "--",
      temperatureSteelBoxEnvironmentZ3Z11R: "--",
      temperatureSteelBoxEnvironmentZ4B7L: "--",
      temperatureSteelBoxEnvironmentZ4B2L: "--",
      temperatureSteelBoxEnvironmentNBK1L: "--",
      temperatureSteelBoxEnvironmentZ3B11L: "--",
      temperatureSteelBoxEnvironmentZ3B1L: "--",
      temperatureSteelBoxEnvironmentZ3Z3R: "--",
      temperatureSteelBoxEnvironmentZ3Z4L: "--",
      temperatureSteelBoxEnvironmentZ3Z11L: "--",
      temperatureSteelBoxEnvironmentZ4B7R: "--",
      temperatureSteelBoxEnvironmentZ4B2R: "--",
      temperatureSteelBoxEnvironmentZ4B1L: "--",
      temperatureSteelBoxEnvironmentZ4Z2R: "--",
      temperatureSteelBoxEnvironmentZ4Z12R: "--",
      temperatureSteelBoxEnvironmentZ5B7L: "--",
      temperatureSteelBoxEnvironmentZ8Z3L: "--",
      temperatureSteelBoxEnvironmentZ8B1R: "--",
      temperatureSteelBoxEnvironmentZ8B11R: "--",
      temperatureSteelBoxEnvironmentSBK1R: "--",
      temperatureSteelBoxEnvironmentZ8Z3R: "--",
      temperatureSteelBoxEnvironmentZ8B1L: "--",
      temperatureSteelBoxEnvironmentZ8B11L: "--",
      temperatureSteelBoxEnvironmentSBK1L: "--",
      temperatureSteelBoxEnvironmentZ6B7R: "--",
      temperatureSteelBoxEnvironmentZ6B12R: "--",
      temperatureSteelBoxEnvironmentZ7Z2L: "--",
      temperatureSteelBoxEnvironmentZ7B1R: "--",
      temperatureSteelBoxEnvironmentZ6B7L: "--",
      temperatureSteelBoxEnvironmentZ6B12L: "--",
      temperatureSteelBoxEnvironmentZ7Z2R: "--",
      temperatureSteelBoxEnvironmentZ7B1L: "--",
      temperatureSteelBoxEnvironmentJ1L: "--",
      temperatureSteelBoxEnvironmentZ6Z6L: "--",
      temperatureSteelBoxEnvironmentZ6B1R: "--",
      temperatureSteelBoxEnvironmentZ6B6R: "--",
      temperatureSteelBoxEnvironmentJ1R: "--",
      temperatureSteelBoxEnvironmentZ6Z6R: "--",
      temperatureSteelBoxEnvironmentZ6B1L: "--",
      temperatureSteelBoxEnvironmentZ6B6L: "--",
      temperatureSteelBoxEnvironmentZ7B2L: "--",
      temperatureSteelBoxEnvironmentZ7B7L: "--",
      temperatureSteelBoxEnvironmentZ8Z10R: "--",
      temperatureSteelBoxEnvironmentZ8B4R: "--",
      temperatureSteelBoxEnvironmentZ7B2R: "--",
      temperatureSteelBoxEnvironmentZ7B7R: "--",
      temperatureSteelBoxEnvironmentZ8Z10L: "--",
      temperatureSteelBoxEnvironmentZ8B4L: "--",

      //running
      runningDehumidifierZ3TowerTop: "--",
      runningDehumidifierZ3TowerMid: "--",
      runningDehumidifierZ4TowerTop: "--",
      runningDehumidifierZ4TowerMid: "--",
      runningDehumidifierZ5TowerTop: "--",
      runningDehumidifierZ5TowerMid: "--",
      runningDehumidifierZ6TowerTop: "--",
      runningDehumidifierZ6TowerMid: "--",
      runningDehumidifierZ7TowerTop: "--",
      runningDehumidifierZ7TowerMid: "--",
      runningDehumidifierZ8TowerTop: "--",
      runningDehumidifierZ8TowerMid: "--",
      runningDehumidifierZ3B5LSteelBoxG1: "--",
      runningDehumidifierZ3B5RSteelBoxG2: "--",
      runningDehumidifierZ4B11LSteelBoxG3: "--",
      runningDehumidifierZ4B11RSteelBoxG4: "--",
      runningDehumidifierZ4Z8RSteelBoxG5: "--",
      runningDehumidifierZ4Z8LSteelBoxG6: "--",
      runningDehumidifierZ5Z1RSteelBoxG7: "--",
      runningDehumidifierZ5Z1LSteelBoxG8: "--",
      runningDehumidifierZ6Z1LSteelBoxG9: "--",
      runningDehumidifierZ6Z1RSteelBoxG10: "--",
      runningDehumidifierZ7Z8LSteelBoxG11: "--",
      runningDehumidifierZ7Z8RSteelBoxG12: "--",
      runningDehumidifierZ7B11RSteelBoxG13: "--",
      runningDehumidifierZ7B11LSteelBoxG14: "--",
      runningDehumidifierZ8B5RSteelBoxG15: "--",
      runningDehumidifierZ8B5LSteelBoxG16: "--",

      //malfunction
      malfunctionDehumidifierZ3TowerTop: "--",
      malfunctionDehumidifierZ3TowerMid: "--",
      malfunctionDehumidifierZ4TowerTop: "--",
      malfunctionDehumidifierZ4TowerMid: "--",
      malfunctionDehumidifierZ5TowerTop: "--",
      malfunctionDehumidifierZ5TowerMid: "--",
      malfunctionDehumidifierZ6TowerTop: "--",
      malfunctionDehumidifierZ6TowerMid: "--",
      malfunctionDehumidifierZ7TowerTop: "--",
      malfunctionDehumidifierZ7TowerMid: "--",
      malfunctionDehumidifierZ8TowerTop: "--",
      malfunctionDehumidifierZ8TowerMid: "--",
      malfunctionDehumidifierZ3B5LSteelBoxG1: "--",
      malfunctionDehumidifierZ3B5RSteelBoxG2: "--",
      malfunctionDehumidifierZ4B11LSteelBoxG3: "--",
      malfunctionDehumidifierZ4B11RSteelBoxG4: "--",
      malfunctionDehumidifierZ4Z8RSteelBoxG5: "--",
      malfunctionDehumidifierZ4Z8LSteelBoxG6: "--",
      malfunctionDehumidifierZ5Z1RSteelBoxG7: "--",
      malfunctionDehumidifierZ5Z1LSteelBoxG8: "--",
      malfunctionDehumidifierZ6Z1LSteelBoxG9: "--",
      malfunctionDehumidifierZ6Z1RSteelBoxG10: "--",
      malfunctionDehumidifierZ7Z8LSteelBoxG11: "--",
      malfunctionDehumidifierZ7Z8RSteelBoxG12: "--",
      malfunctionDehumidifierZ7B11RSteelBoxG13: "--",
      malfunctionDehumidifierZ7B11LSteelBoxG14: "--",
      malfunctionDehumidifierZ8B5RSteelBoxG15: "--",
      malfunctionDehumidifierZ8B5LSteelBoxG16: "--",

      //error
      errorZ3TowerTop: "--",
      errorZ3TowerMid: "--",
      errorZ4TowerTop: "--",
      errorZ4TowerMid: "--",
      errorZ5TowerTop: "--",
      errorZ5TowerMid: "--",
      errorZ6TowerTop: "--",
      errorZ6TowerMid: "--",
      errorZ7TowerTop: "--",
      errorZ7TowerMid: "--",
      errorZ8TowerTop: "--",
      errorZ8TowerMid: "--",
      errorZ3B5LSteelBoxG1: "--",
      errorZ3B5RSteelBoxG2: "--",
      errorZ4B11LSteelBoxG3: "--",
      errorZ4B11RSteelBoxG4: "--",
      errorZ4Z8RSteelBoxG5: "--",
      errorZ4Z8LSteelBoxG6: "--",
      errorZ5Z1RSteelBoxG7: "--",
      errorZ5Z1LSteelBoxG8: "--",
      errorZ6Z1LSteelBoxG9: "--",
      errorZ6Z1RSteelBoxG10: "--",
      errorZ7Z8LSteelBoxG11: "--",
      errorZ7Z8RSteelBoxG12: "--",
      errorZ7B11RSteelBoxG13: "--",
      errorZ7B11LSteelBoxG14: "--",
      errorZ8B5RSteelBoxG15: "--",
      errorZ8B5LSteelBoxG16: "--",

      //running class
      runningClassZ3TowerTop: "--",
      runningClassZ3TowerMid: "--",
      runningClassZ4TowerTop: "--",
      runningClassZ4TowerMid: "--",
      runningClassZ5TowerTop: "--",
      runningClassZ5TowerMid: "--",
      runningClassZ6TowerTop: "--",
      runningClassZ6TowerMid: "--",
      runningClassZ7TowerTop: "--",
      runningClassZ7TowerMid: "--",
      runningClassZ8TowerTop: "--",
      runningClassZ8TowerMid: "--",
      runningClassZ3B5LSteelBoxG1: "--",
      runningClassZ3B5RSteelBoxG2: "--",
      runningClassZ4B11LSteelBoxG3: "--",
      runningClassZ4B11RSteelBoxG4: "--",
      runningClassZ4Z8RSteelBoxG5: "--",
      runningClassZ4Z8LSteelBoxG6: "--",
      runningClassZ5Z1RSteelBoxG7: "--",
      runningClassZ5Z1LSteelBoxG8: "--",
      runningClassZ6Z1LSteelBoxG9: "--",
      runningClassZ6Z1RSteelBoxG10: "--",
      runningClassZ7Z8LSteelBoxG11: "--",
      runningClassZ7Z8RSteelBoxG12: "--",
      runningClassZ7B11RSteelBoxG13: "--",
      runningClassZ7B11LSteelBoxG14: "--",
      runningClassZ8B5RSteelBoxG15: "--",
      runningClassZ8B5LSteelBoxG16: "--",

      //humidity allowed max
      humidityAllowedMaxDehumidifierZ3TowerTop: "--",
      humidityAllowedMaxDehumidifierZ3TowerMid: "--",
      humidityAllowedMaxDehumidifierZ4TowerTop: "--",
      humidityAllowedMaxDehumidifierZ4TowerMid: "--",
      humidityAllowedMaxDehumidifierZ5TowerTop: "--",
      humidityAllowedMaxDehumidifierZ5TowerMid: "--",
      humidityAllowedMaxDehumidifierZ6TowerTop: "--",
      humidityAllowedMaxDehumidifierZ6TowerMid: "--",
      humidityAllowedMaxDehumidifierZ7TowerTop: "--",
      humidityAllowedMaxDehumidifierZ7TowerMid: "--",
      humidityAllowedMaxDehumidifierZ8TowerTop: "--",
      humidityAllowedMaxDehumidifierZ8TowerMid: "--",

      humidityAllowedMaxDehumidifierZ3B5LSteelBoxG1: "--",
      humidityAllowedMaxDehumidifierZ3B5RSteelBoxG2: "--",
      humidityAllowedMaxDehumidifierZ4B11LSteelBoxG3: "--",
      humidityAllowedMaxDehumidifierZ4B11RSteelBoxG4: "--",
      humidityAllowedMaxDehumidifierZ4Z8RSteelBoxG5: "--",
      humidityAllowedMaxDehumidifierZ4Z8LSteelBoxG6: "--",
      humidityAllowedMaxDehumidifierZ5Z1RSteelBoxG7: "--",
      humidityAllowedMaxDehumidifierZ5Z1LSteelBoxG8: "--",
      humidityAllowedMaxDehumidifierZ6Z1LSteelBoxG9: "--",
      humidityAllowedMaxDehumidifierZ6Z1RSteelBoxG10: "--",
      humidityAllowedMaxDehumidifierZ7Z8LSteelBoxG11: "--",
      humidityAllowedMaxDehumidifierZ7Z8RSteelBoxG12: "--",
      humidityAllowedMaxDehumidifierZ7B11RSteelBoxG13: "--",
      humidityAllowedMaxDehumidifierZ7B11LSteelBoxG14: "--",
      humidityAllowedMaxDehumidifierZ8B5RSteelBoxG15: "--",
      humidityAllowedMaxDehumidifierZ8B5LSteelBoxG16: "--",

      humidityAllowedMaxZ3TowerTopEnvironmentUp: "--",
      humidityAllowedMaxZ3TowerTopEnvironmentMid: "--",
      humidityAllowedMaxZ3TowerTopEnvironmentDown: "--",
      humidityAllowedMaxZ3TowerMidEnvironmentUp: "--",
      humidityAllowedMaxZ3TowerMidEnvironmentMid: "--",
      humidityAllowedMaxZ3TowerMidEnvironmentDown: "--",
      humidityAllowedMaxZ4TowerTopEnvironmentUp: "--",
      humidityAllowedMaxZ4TowerTopEnvironmentMid: "--",
      humidityAllowedMaxZ4TowerTopEnvironmentDown: "--",
      humidityAllowedMaxZ4TowerMidEnvironmentUp: "--",
      humidityAllowedMaxZ4TowerMidEnvironmentMid: "--",
      humidityAllowedMaxZ4TowerMidEnvironmentDown: "--",
      humidityAllowedMaxZ5TowerTopEnvironmentUp: "--",
      humidityAllowedMaxZ5TowerTopEnvironmentMid: "--",
      humidityAllowedMaxZ5TowerTopEnvironmentDown: "--",
      humidityAllowedMaxZ5TowerMidEnvironmentUp: "--",
      humidityAllowedMaxZ5TowerMidEnvironmentMid: "--",
      humidityAllowedMaxZ5TowerMidEnvironmentDown: "--",
      humidityAllowedMaxZ6TowerTopEnvironmentUp: "--",
      humidityAllowedMaxZ6TowerTopEnvironmentMid: "--",
      humidityAllowedMaxZ6TowerTopEnvironmentDown: "--",
      humidityAllowedMaxZ6TowerMidEnvironmentUp: "--",
      humidityAllowedMaxZ6TowerMidEnvironmentMid: "--",
      humidityAllowedMaxZ6TowerMidEnvironmentDown: "--",
      humidityAllowedMaxZ7TowerTopEnvironmentUp: "--",
      humidityAllowedMaxZ7TowerTopEnvironmentMid: "--",
      humidityAllowedMaxZ7TowerTopEnvironmentDown: "--",
      humidityAllowedMaxZ7TowerMidEnvironmentUp: "--",
      humidityAllowedMaxZ7TowerMidEnvironmentMid: "--",
      humidityAllowedMaxZ7TowerMidEnvironmentDown: "--",
      humidityAllowedMaxZ8TowerTopEnvironmentUp: "--",
      humidityAllowedMaxZ8TowerTopEnvironmentMid: "--",
      humidityAllowedMaxZ8TowerTopEnvironmentDown: "--",
      humidityAllowedMaxZ8TowerMidEnvironmentUp: "--",
      humidityAllowedMaxZ8TowerMidEnvironmentMid: "--",
      humidityAllowedMaxZ8TowerMidEnvironmentDown: "--",

      humidityAllowedMaxSteelBoxEnvironmentZ5B6R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ5B1R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ5Z6L: "--",
      humidityAllowedMaxSteelBoxEnvironmentJ3L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ4B1R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ4Z2L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ4Z12L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ5B7R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ5B6L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ5B1L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ5Z6R: "--",
      humidityAllowedMaxSteelBoxEnvironmentJ3R: "--",
      humidityAllowedMaxSteelBoxEnvironmentNBK1R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ3B11R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ3B1R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ3Z3L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ3Z4R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ3Z11R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ4B7L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ4B2L: "--",
      humidityAllowedMaxSteelBoxEnvironmentNBK1L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ3B11L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ3B1L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ3Z3R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ3Z4L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ3Z11L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ4B7R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ4B2R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ4B1L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ4Z2R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ4Z12R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ5B7L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ8Z3L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ8B1R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ8B11R: "--",
      humidityAllowedMaxSteelBoxEnvironmentSBK1R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ8Z3R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ8B1L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ8B11L: "--",
      humidityAllowedMaxSteelBoxEnvironmentSBK1L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ6B7R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ6B12R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ7Z2L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ7B1R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ6B7L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ6B12L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ7Z2R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ7B1L: "--",
      humidityAllowedMaxSteelBoxEnvironmentJ1L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ6Z6L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ6B1R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ6B6R: "--",
      humidityAllowedMaxSteelBoxEnvironmentJ1R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ6Z6R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ6B1L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ6B6L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ7B2L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ7B7L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ8Z10R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ8B4R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ7B2R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ7B7R: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ8Z10L: "--",
      humidityAllowedMaxSteelBoxEnvironmentZ8B4L: "--",

      //humidity tooltip error
      humidityTooltipErrorDehumidifierZ3TowerTop: "--",
      humidityTooltipErrorDehumidifierZ3TowerMid: "--",
      humidityTooltipErrorDehumidifierZ4TowerTop: "--",
      humidityTooltipErrorDehumidifierZ4TowerMid: "--",
      humidityTooltipErrorDehumidifierZ5TowerTop: "--",
      humidityTooltipErrorDehumidifierZ5TowerMid: "--",
      humidityTooltipErrorDehumidifierZ6TowerTop: "--",
      humidityTooltipErrorDehumidifierZ6TowerMid: "--",
      humidityTooltipErrorDehumidifierZ7TowerTop: "--",
      humidityTooltipErrorDehumidifierZ7TowerMid: "--",
      humidityTooltipErrorDehumidifierZ8TowerTop: "--",
      humidityTooltipErrorDehumidifierZ8TowerMid: "--",

      humidityTooltipErrorDehumidifierZ3B5LSteelBoxG1: "--",
      humidityTooltipErrorDehumidifierZ3B5RSteelBoxG2: "--",
      humidityTooltipErrorDehumidifierZ4B11LSteelBoxG3: "--",
      humidityTooltipErrorDehumidifierZ4B11RSteelBoxG4: "--",
      humidityTooltipErrorDehumidifierZ4Z8RSteelBoxG5: "--",
      humidityTooltipErrorDehumidifierZ4Z8LSteelBoxG6: "--",
      humidityTooltipErrorDehumidifierZ5Z1RSteelBoxG7: "--",
      humidityTooltipErrorDehumidifierZ5Z1LSteelBoxG8: "--",
      humidityTooltipErrorDehumidifierZ6Z1LSteelBoxG9: "--",
      humidityTooltipErrorDehumidifierZ6Z1RSteelBoxG10: "--",
      humidityTooltipErrorDehumidifierZ7Z8LSteelBoxG11: "--",
      humidityTooltipErrorDehumidifierZ7Z8RSteelBoxG12: "--",
      humidityTooltipErrorDehumidifierZ7B11RSteelBoxG13: "--",
      humidityTooltipErrorDehumidifierZ7B11LSteelBoxG14: "--",
      humidityTooltipErrorDehumidifierZ8B5RSteelBoxG15: "--",
      humidityTooltipErrorDehumidifierZ8B5LSteelBoxG16: "--",

      humidityTooltipErrorZ3TowerTopEnvironmentUp: "--",
      humidityTooltipErrorZ3TowerTopEnvironmentMid: "--",
      humidityTooltipErrorZ3TowerTopEnvironmentDown: "--",
      humidityTooltipErrorZ3TowerMidEnvironmentUp: "--",
      humidityTooltipErrorZ3TowerMidEnvironmentMid: "--",
      humidityTooltipErrorZ3TowerMidEnvironmentDown: "--",
      humidityTooltipErrorZ4TowerTopEnvironmentUp: "--",
      humidityTooltipErrorZ4TowerTopEnvironmentMid: "--",
      humidityTooltipErrorZ4TowerTopEnvironmentDown: "--",
      humidityTooltipErrorZ4TowerMidEnvironmentUp: "--",
      humidityTooltipErrorZ4TowerMidEnvironmentMid: "--",
      humidityTooltipErrorZ4TowerMidEnvironmentDown: "--",
      humidityTooltipErrorZ5TowerTopEnvironmentUp: "--",
      humidityTooltipErrorZ5TowerTopEnvironmentMid: "--",
      humidityTooltipErrorZ5TowerTopEnvironmentDown: "--",
      humidityTooltipErrorZ5TowerMidEnvironmentUp: "--",
      humidityTooltipErrorZ5TowerMidEnvironmentMid: "--",
      humidityTooltipErrorZ5TowerMidEnvironmentDown: "--",
      humidityTooltipErrorZ6TowerTopEnvironmentUp: "--",
      humidityTooltipErrorZ6TowerTopEnvironmentMid: "--",
      humidityTooltipErrorZ6TowerTopEnvironmentDown: "--",
      humidityTooltipErrorZ6TowerMidEnvironmentUp: "--",
      humidityTooltipErrorZ6TowerMidEnvironmentMid: "--",
      humidityTooltipErrorZ6TowerMidEnvironmentDown: "--",
      humidityTooltipErrorZ7TowerTopEnvironmentUp: "--",
      humidityTooltipErrorZ7TowerTopEnvironmentMid: "--",
      humidityTooltipErrorZ7TowerTopEnvironmentDown: "--",
      humidityTooltipErrorZ7TowerMidEnvironmentUp: "--",
      humidityTooltipErrorZ7TowerMidEnvironmentMid: "--",
      humidityTooltipErrorZ7TowerMidEnvironmentDown: "--",
      humidityTooltipErrorZ8TowerTopEnvironmentUp: "--",
      humidityTooltipErrorZ8TowerTopEnvironmentMid: "--",
      humidityTooltipErrorZ8TowerTopEnvironmentDown: "--",
      humidityTooltipErrorZ8TowerMidEnvironmentUp: "--",
      humidityTooltipErrorZ8TowerMidEnvironmentMid: "--",
      humidityTooltipErrorZ8TowerMidEnvironmentDown: "--",

      humidityTooltipErrorSteelBoxEnvironmentZ5B6R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ5B1R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ5Z6L: "--",
      humidityTooltipErrorSteelBoxEnvironmentJ3L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ4B1R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ4Z2L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ4Z12L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ5B7R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ5B6L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ5B1L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ5Z6R: "--",
      humidityTooltipErrorSteelBoxEnvironmentJ3R: "--",
      humidityTooltipErrorSteelBoxEnvironmentNBK1R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ3B11R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ3B1R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ3Z3L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ3Z4R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ3Z11R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ4B7L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ4B2L: "--",
      humidityTooltipErrorSteelBoxEnvironmentNBK1L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ3B11L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ3B1L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ3Z3R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ3Z4L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ3Z11L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ4B7R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ4B2R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ4B1L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ4Z2R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ4Z12R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ5B7L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ8Z3L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ8B1R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ8B11R: "--",
      humidityTooltipErrorSteelBoxEnvironmentSBK1R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ8Z3R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ8B1L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ8B11L: "--",
      humidityTooltipErrorSteelBoxEnvironmentSBK1L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ6B7R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ6B12R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ7Z2L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ7B1R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ6B7L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ6B12L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ7Z2R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ7B1L: "--",
      humidityTooltipErrorSteelBoxEnvironmentJ1L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ6Z6L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ6B1R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ6B6R: "--",
      humidityTooltipErrorSteelBoxEnvironmentJ1R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ6Z6R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ6B1L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ6B6L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ7B2L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ7B7L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ8Z10R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ8B4R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ7B2R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ7B7R: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ8Z10L: "--",
      humidityTooltipErrorSteelBoxEnvironmentZ8B4L: "--",

      dataNameIdDict: {
        //humidity, temperature
        humidityDehumidifierZ3TowerMid: "91ae8484-fa72-4536-bbcf-227485d00984",
        humidityDehumidifierZ3TowerTop: "a8355f4b-f4f3-4175-bb43-48b6406edf37",
        humidityDehumidifierZ4TowerMid: "5d116a33-9429-4ea6-9c12-70ca1a3615c9",
        humidityDehumidifierZ4TowerTop: "1a50053a-6642-4b2f-8485-448ad89d99d0",
        humidityDehumidifierZ5TowerMid: "e63f2494-2009-431b-b169-d56c178fcc02",
        humidityDehumidifierZ5TowerTop: "7c6e3109-18ff-4c72-8a86-1bf25ec57260",
        humidityDehumidifierZ6TowerMid: "7d85ad73-ed97-488f-a041-2a5a6a6be417",
        humidityDehumidifierZ6TowerTop: "4404eb6b-a447-45cc-8739-9dd6d7b5c1c1",
        humidityDehumidifierZ7TowerMid: "b1831c64-d258-498a-9323-4fba75f44760",
        humidityDehumidifierZ7TowerTop: "8635be2d-8dbb-4407-b101-3fc48e399a6c",
        humidityDehumidifierZ8TowerMid: "GUID",
        humidityDehumidifierZ8TowerTop: "6a1c4917-87b6-46fa-8112-d81e787c680a",

        humidityDehumidifierZ3B5LSteelBoxG1: "3605966d-1a70-402e-b3a8-8c880d6bfca2",
        humidityDehumidifierZ3B5RSteelBoxG2: "e744b4c7-a28c-4d0c-a6b7-4432c5ed0c07",
        humidityDehumidifierZ4B11LSteelBoxG3: "52bb5182-60f9-44f2-9863-db862e969c22",
        humidityDehumidifierZ4B11RSteelBoxG4: "66fb152b-c0be-49d5-914f-61929d396ffa",
        humidityDehumidifierZ4Z8RSteelBoxG5: "7b44ec39-64a7-41fa-bbb8-c847567eebc5",
        humidityDehumidifierZ4Z8LSteelBoxG6: "bc5eda69-2f9e-4508-900b-f3ee35f9eba7",
        humidityDehumidifierZ5Z1RSteelBoxG7: "6b45d5e5-b80f-4df1-98ff-c2f9ca718ac2",
        humidityDehumidifierZ5Z1LSteelBoxG8: "667dc54f-939e-4483-8767-8ec2a1a73594",
        humidityDehumidifierZ6Z1LSteelBoxG9: "e311a943-28b9-4b96-bf94-31c803d754fd",
        humidityDehumidifierZ6Z1RSteelBoxG10: "bd2e5432-bf65-4693-9280-0d77bce2c65c",
        humidityDehumidifierZ7Z8LSteelBoxG11: "995f666c-4943-4341-b874-5f7e14d9953a",
        humidityDehumidifierZ7Z8RSteelBoxG12: "a6f2efd7-3a04-45e9-86a6-d42152e2894f",
        humidityDehumidifierZ7B11RSteelBoxG13: "787bba13-fc52-44ca-9af1-8c6ac492a67d",
        humidityDehumidifierZ7B11LSteelBoxG14: "122c0972-7f0a-43e1-b5cd-b3b4bd73b9d3",
        humidityDehumidifierZ8B5RSteelBoxG15: "38cc55e1-1324-4262-ba21-26b599c93612",
        humidityDehumidifierZ8B5LSteelBoxG16: "61d78ff5-30f1-4bb7-a008-5aeb3a602361",

        temperatureDehumidifierZ3TowerMid: "d37a3c57-8c3d-4054-bdc8-fe446f3927b9",
        temperatureDehumidifierZ3TowerTop: "64855950-bd6c-4163-ae4e-2457a590b424",
        temperatureDehumidifierZ4TowerMid: "06636180-c748-4cbd-b017-041253682a1b",
        temperatureDehumidifierZ4TowerTop: "f54a7096-7073-4dee-82fd-59027ccb1b29",
        temperatureDehumidifierZ5TowerMid: "29678169-d33d-4b7b-b173-0fe4b22f8b02",
        temperatureDehumidifierZ5TowerTop: "795fdd42-e9dd-48a5-8c92-d00734b280fa",
        temperatureDehumidifierZ6TowerMid: "13f6ed68-8425-40d6-b076-694b6bcc445e",
        temperatureDehumidifierZ6TowerTop: "01742421-cc73-45ae-a4db-6536f26d9255",
        temperatureDehumidifierZ7TowerMid: "3e8949c8-d51c-4d31-9d4c-ef0a5e4e976e",
        temperatureDehumidifierZ7TowerTop: "ac6ab09e-9e2e-45da-a69a-110f71ab85fa",
        temperatureDehumidifierZ8TowerMid: "GUID",
        temperatureDehumidifierZ8TowerTop: "3b5eda18-9a61-4724-8774-560d362db738",

        temperatureDehumidifierZ3B5LSteelBoxG1: "533723fd-d7a8-4dbf-9acd-afffc70a4afb",
        temperatureDehumidifierZ3B5RSteelBoxG2: "d75ba837-470e-4110-8dd4-a390a1e19eaa",
        temperatureDehumidifierZ4B11LSteelBoxG3: "d1881d2c-f6ad-496b-9765-ade41f942efd",
        temperatureDehumidifierZ4B11RSteelBoxG4: "607a9cb4-f270-46df-9347-aa623d764b77",
        temperatureDehumidifierZ4Z8RSteelBoxG5: "0df004a0-e6db-4931-8a68-bc4d74b97a3d",
        temperatureDehumidifierZ4Z8LSteelBoxG6: "487650cd-59d3-4a39-b33f-afa68459686c",
        temperatureDehumidifierZ5Z1RSteelBoxG7: "bdca6e66-01e9-4f50-9392-ff3a7bbf212f",
        temperatureDehumidifierZ5Z1LSteelBoxG8: "d6e9863f-c89b-4352-8c3f-9b5fd8b5d131",
        temperatureDehumidifierZ6Z1LSteelBoxG9: "86fea99f-1e88-4b04-b601-dec834985a7d",
        temperatureDehumidifierZ6Z1RSteelBoxG10: "b84461dd-9449-408f-ac68-bb117865480a",
        temperatureDehumidifierZ7Z8LSteelBoxG11: "3465e379-1999-4d08-9707-97c60712b5ec",
        temperatureDehumidifierZ7Z8RSteelBoxG12: "1ec703b0-6c65-4bc3-ac58-30c6bd94cb6d",
        temperatureDehumidifierZ7B11RSteelBoxG13: "be2a901a-84de-4f73-a330-db500de8f103",
        temperatureDehumidifierZ7B11LSteelBoxG14: "ec49e09a-c221-4321-bc4d-7a64e301dfcd",
        temperatureDehumidifierZ8B5RSteelBoxG15: "9f49fdc2-e5f6-4580-89ec-e8c207e96ba4",
        temperatureDehumidifierZ8B5LSteelBoxG16: "584c4159-448d-4da2-98c8-0fbab54ee194",

        humidityZ3TowerMidEnvironmentDown: "4993762c-ce5b-44db-9373-959bbc19ac88",
        humidityZ3TowerMidEnvironmentMid: "cf999266-3959-4cc2-a218-3a7e45b244ec",
        humidityZ3TowerMidEnvironmentUp: "d754da32-51b0-41fb-b5ca-e9a77c991508",
        humidityZ3TowerTopEnvironmentDown: "3c545c28-09e6-40d9-968b-75c8f92564ee",
        humidityZ3TowerTopEnvironmentMid: "6d53aec4-a9f6-4575-bfa3-e94f9174c12c",
        humidityZ3TowerTopEnvironmentUp: "043033cb-8aec-4cd0-8ed6-077e21ecad87",
        humidityZ4TowerMidEnvironmentDown: "7d62686f-b955-4542-a68f-4531b8e380a9",
        humidityZ4TowerMidEnvironmentMid: "e46e900c-00d4-4d4e-a1a4-dc0c2fe2be22",
        humidityZ4TowerMidEnvironmentUp: "21315ac6-9d0d-4b3c-9a11-3562c1e0254c",
        humidityZ4TowerTopEnvironmentDown: "eb14a35b-d46d-4d09-9ee4-f9b9f2880485",
        humidityZ4TowerTopEnvironmentMid: "87866948-3674-46ca-b70e-5e6a12d695e3",
        humidityZ4TowerTopEnvironmentUp: "8a9cebdb-1786-47f2-9f9e-86317cd06132",
        humidityZ5TowerMidEnvironmentDown: "b56c3ba1-f85d-47c3-8900-ef99eb766838",
        humidityZ5TowerMidEnvironmentMid: "3947a0d6-3873-449f-ae68-ccf7b9a353a9",
        humidityZ5TowerMidEnvironmentUp: "8603c4f1-9d24-4f6f-99f7-c80977a28a9e",
        humidityZ5TowerTopEnvironmentDown: "95322bb5-d441-4efc-a306-0343885a9056",
        humidityZ5TowerTopEnvironmentMid: "3f19ebed-f8a0-488a-b0ce-21bd639e4fe4",
        humidityZ5TowerTopEnvironmentUp: "72be3ac0-4b49-46d7-9d0b-cc4e384ccaee",
        humidityZ6TowerMidEnvironmentDown: "2372aa93-4e8a-4da0-a6a2-a770f1fbc99a",
        humidityZ6TowerMidEnvironmentMid: "a28e4ba8-e3dc-4262-9ccb-da8a80832708",
        humidityZ6TowerMidEnvironmentUp: "95b75401-e353-4f3d-94ad-892e0bfca9d9",
        humidityZ6TowerTopEnvironmentDown: "0f7a5716-23fc-4f23-862e-b705e9efd3ac",
        humidityZ6TowerTopEnvironmentMid: "950525c9-defe-49fc-a541-026f4b208ed3",
        humidityZ6TowerTopEnvironmentUp: "3f7acdb7-dd95-454b-9e3a-e7f136fcba70",
        humidityZ7TowerMidEnvironmentDown: "340161df-96e4-4480-b352-ea7d9c036a7b",
        humidityZ7TowerMidEnvironmentMid: "5d870b4f-bebf-448b-bce0-4b66c8f9df55",
        humidityZ7TowerMidEnvironmentUp: "047a3dad-ca1c-48a7-9dc7-9ce32553aa97",
        humidityZ7TowerTopEnvironmentDown: "a4a44370-0b07-4afc-a73e-3ceb4167d43b",
        humidityZ7TowerTopEnvironmentMid: "1d64c9bb-31a4-4d6c-9852-e5c67933eff9",
        humidityZ7TowerTopEnvironmentUp: "ebd0caf6-063a-4391-9a20-b177cf94ff31",
        humidityZ8TowerTopEnvironmentDown: "7794e86d-98aa-471d-b88c-4d9c945bad38",
        humidityZ8TowerTopEnvironmentMid: "f7633fec-d517-4abe-9f9d-04c41b748d87",
        humidityZ8TowerTopEnvironmentUp: "42da9d50-2a83-4014-b9ed-011a1713426a",
        humidityZ8TowerMidEnvironmentUp: "GUID",
        humidityZ8TowerMidEnvironmentMid: "GUID",
        humidityZ8TowerMidEnvironmentDown: "GUID",

        humiditySteelBoxEnvironmentJ1L: "d757bd03-388b-4cc9-ae60-76a3bd56cb92",
        humiditySteelBoxEnvironmentJ1R: "630109f2-286d-4543-b08a-4fc156d454d9",
        humiditySteelBoxEnvironmentJ3L: "1499ddef-148b-4907-97dc-a7a158f06a33",
        humiditySteelBoxEnvironmentJ3R: "a9cbb9f3-4542-4100-aa11-a828080b40db",
        humiditySteelBoxEnvironmentNBK1L: "4c9062f9-8757-41fb-9c7e-715157782742",
        humiditySteelBoxEnvironmentNBK1R: "9a43d9b9-97b8-48ed-97fa-41345ff6b1ea",
        humiditySteelBoxEnvironmentSBK1L: "7fd56fd6-0c3e-43ae-97db-a9698dacbed2",
        humiditySteelBoxEnvironmentSBK1R: "4cc57342-b48a-40dd-bc1c-2cb8889b0803",
        humiditySteelBoxEnvironmentZ3B11L: "5dc7000b-cd2c-459a-9cf5-88cd8d11017b",
        humiditySteelBoxEnvironmentZ3B11R: "408bb3f4-819c-4a47-8fa4-c9abae496403",
        humiditySteelBoxEnvironmentZ3B1L: "436b6e6c-9c01-4cff-b6d4-1c13d3e05175",
        humiditySteelBoxEnvironmentZ3B1R: "f70cf50c-a9c0-4f81-bd92-c60a2e58eb86",
        humiditySteelBoxEnvironmentZ3Z11L: "6bddf58c-0ba8-45c4-b5fc-a21264f4e609",
        humiditySteelBoxEnvironmentZ3Z11R: "fbef463a-2bbf-4eb6-be84-6e515249c71e",
        humiditySteelBoxEnvironmentZ3Z3L: "ef99103d-01e7-42e0-b4c8-e2f05b253f59",
        humiditySteelBoxEnvironmentZ3Z3R: "da6be5a7-f9f0-4ce3-9b44-83a4854aa1b7",
        humiditySteelBoxEnvironmentZ3Z4L: "b8684cf4-fa64-426d-bdae-78162cdb8f85",
        humiditySteelBoxEnvironmentZ3Z4R: "a902c739-631a-49aa-926e-bcba1371c760",
        humiditySteelBoxEnvironmentZ4B1L: "0a8340f0-8905-4cee-88e7-590d6ef84f1a",
        humiditySteelBoxEnvironmentZ4B1R: "986fa3ee-ef35-4793-a76d-4503eb635dd3",
        humiditySteelBoxEnvironmentZ4B2L: "f53739fc-4011-463b-9a07-f47bd7817586",
        humiditySteelBoxEnvironmentZ4B2R: "e511f1b7-7059-4ea6-b992-7253ba2b2a72",
        humiditySteelBoxEnvironmentZ4B7L: "7586a52d-da9c-4904-920a-7e7fd3e1cb48",
        humiditySteelBoxEnvironmentZ4B7R: "1ce2a3e5-ffcf-4334-80c7-29a6e38fc33c",
        humiditySteelBoxEnvironmentZ4Z12L: "5a2e28f3-939f-447b-bd05-40789b417ed1",
        humiditySteelBoxEnvironmentZ4Z12R: "5d01db45-b188-4244-951a-1199d8dab3f6",
        humiditySteelBoxEnvironmentZ4Z2L: "68fe2c60-fe05-4285-b37c-4fa174b925af",
        humiditySteelBoxEnvironmentZ4Z2R: "7c65f7c8-6e7a-47d9-97d5-6356a8cee0a1",
        humiditySteelBoxEnvironmentZ5B1L: "e64d8a2c-466b-449f-8223-6a33c9b5a575",
        humiditySteelBoxEnvironmentZ5B1R: "fa2435d7-64f1-490b-a760-d6c8b3eedf20",
        humiditySteelBoxEnvironmentZ5B6L: "55872f71-3d07-4804-be6a-c402bc3ac5c9",
        humiditySteelBoxEnvironmentZ5B6R: "4779cc5d-da22-49be-9eb3-ead0c18fc5f1",
        humiditySteelBoxEnvironmentZ5B7L: "9bb0c9f3-d2c9-41d6-aa5d-05608a6b82a9",
        humiditySteelBoxEnvironmentZ5B7R: "1dabce70-5c42-40b3-97c5-50861441e557",
        humiditySteelBoxEnvironmentZ5Z6L: "e16fbbdf-8851-4aa6-97a1-13e950bb9e78",
        humiditySteelBoxEnvironmentZ5Z6R: "6dc4690d-dae5-4c4d-9736-ae0654bed4c1",
        humiditySteelBoxEnvironmentZ6B12L: "5a4d3b75-428b-4853-98bc-46c6bae175e3",
        humiditySteelBoxEnvironmentZ6B12R: "ebaa11c1-41bb-433f-89c5-e8305b8d037c",
        humiditySteelBoxEnvironmentZ6B1L: "4ec1deee-eeac-4cb1-8b34-5dd3e203aee2",
        humiditySteelBoxEnvironmentZ6B1R: "41dbce80-0dbb-494b-8af1-d15a4e5c18da",
        humiditySteelBoxEnvironmentZ6B6L: "5905ae20-31a1-49f9-b4ac-672d16391ca5",
        humiditySteelBoxEnvironmentZ6B6R: "150b79ac-f03a-4555-8c0b-3fa7d6f78f6e",
        humiditySteelBoxEnvironmentZ6B7L: "0149bb1b-eb51-42bb-b192-045454c601b4",
        humiditySteelBoxEnvironmentZ6B7R: "58a62ade-9a2f-43d0-b241-4f43e8ebb11f",
        humiditySteelBoxEnvironmentZ6Z6L: "78f8396e-6d38-46e7-83da-3e3ecbd58ed8",
        humiditySteelBoxEnvironmentZ6Z6R: "c5dd12a3-991f-4b1d-aefd-f95cbd5aec54",
        humiditySteelBoxEnvironmentZ7B1L: "8bdd38cd-7a70-496c-b90e-21b859a6d1f3",
        humiditySteelBoxEnvironmentZ7B1R: "e6d8dd94-9585-469d-8c9a-653a2f46dcf3",
        humiditySteelBoxEnvironmentZ7B2L: "89634b5d-2248-404b-ba90-74ad920f5939",
        humiditySteelBoxEnvironmentZ7B2R: "adb119c3-d029-4bba-98b4-6f9bf3811a99",
        humiditySteelBoxEnvironmentZ7B7L: "79920847-5408-4d90-96ee-b81fc46a08b1",
        humiditySteelBoxEnvironmentZ7B7R: "021da40a-6448-4a76-9817-66dbdda69599",
        humiditySteelBoxEnvironmentZ7Z2L: "1cb39d0d-5a4d-457b-a6f2-9a0b20c74563",
        humiditySteelBoxEnvironmentZ7Z2R: "30e51763-7795-4440-a5f3-eb0a56bc1b45",
        humiditySteelBoxEnvironmentZ8B11L: "c78a0045-c875-42e7-9fdf-db2e0c0016dd",
        humiditySteelBoxEnvironmentZ8B11R: "6a1e3277-7b9c-4e5f-b12b-cd1dc4e8c2c0",
        humiditySteelBoxEnvironmentZ8B1L: "a1620726-95af-4f07-8fd4-c6196ccd90b1",
        humiditySteelBoxEnvironmentZ8B1R: "0bca3ad5-e290-4773-8389-4cdc4f75a362",
        humiditySteelBoxEnvironmentZ8B4L: "6a879f04-e422-40a8-a66f-36fd82ebcd20",
        humiditySteelBoxEnvironmentZ8B4R: "6ae4593e-8665-40ae-b873-9a2839aa422e",
        humiditySteelBoxEnvironmentZ8Z10L: "b031623a-abf1-4987-b0a9-b5a3a268fdea",
        humiditySteelBoxEnvironmentZ8Z10R: "a919955f-dfd3-4a21-98a5-b5a96db33017",
        humiditySteelBoxEnvironmentZ8Z3L: "299c2fb6-419a-4ac6-adae-70b41e367243",
        humiditySteelBoxEnvironmentZ8Z3R: "a0580166-531d-4d4a-b829-5d656f1dae11",

        temperatureZ3TowerMidEnvironmentDown: "ba82c226-a535-434e-ae9c-34409e8d558b",
        temperatureZ3TowerMidEnvironmentMid: "fe442d7d-2230-4bde-8260-10bd69537f9e",
        temperatureZ3TowerMidEnvironmentUp: "06a3356a-928d-471f-8f92-cead40a94c7f",
        temperatureZ3TowerTopEnvironmentDown: "ada97a2e-e0b1-41e4-b334-368e025bc24d",
        temperatureZ3TowerTopEnvironmentMid: "158517c4-4369-42cb-865c-535332078b15",
        temperatureZ3TowerTopEnvironmentUp: "4a863572-f2e2-48ea-b36b-83d2924991f8",
        temperatureZ4TowerMidEnvironmentDown: "891738aa-0afa-407d-8f4f-d4b39811aaa0",
        temperatureZ4TowerMidEnvironmentMid: "1fb043a8-da20-45a7-ae59-c9e313e06b63",
        temperatureZ4TowerMidEnvironmentUp: "c1dbcd0d-915a-42e7-af63-46279d5a81c8",
        temperatureZ4TowerTopEnvironmentDown: "2069f59e-8cd0-4a0c-8e51-ba9ed157459b",
        temperatureZ4TowerTopEnvironmentMid: "8bee0858-c2fb-4be0-8908-cc643c7bf489",
        temperatureZ4TowerTopEnvironmentUp: "254c4e8e-161d-4b75-b1ce-139ec8554850",
        temperatureZ5TowerMidEnvironmentDown: "84f92ef0-dabb-453a-9f44-e28bcde1a8ca",
        temperatureZ5TowerMidEnvironmentMid: "907b3261-5937-4f19-8a44-e93e26180663",
        temperatureZ5TowerMidEnvironmentUp: "08868fba-559e-47c1-9b54-b86f374f2a1a",
        temperatureZ5TowerTopEnvironmentDown: "c0787000-9946-4419-9f85-126161a6a3e9",
        temperatureZ5TowerTopEnvironmentMid: "1e47bf1e-66a5-4e64-a69e-ea9ad153bf95",
        temperatureZ5TowerTopEnvironmentUp: "8b3b1a1e-3d81-44c0-9cb6-25eb698ddb29",
        temperatureZ6TowerMidEnvironmentDown: "f82662a8-7c5d-4f19-845a-97df9545d0eb",
        temperatureZ6TowerMidEnvironmentMid: "5bec5913-01e5-488e-8efe-b895fc9b2b19",
        temperatureZ6TowerMidEnvironmentUp: "77e76e64-a66f-45dd-ac52-54b84e3e95a5",
        temperatureZ6TowerTopEnvironmentDown: "ad6156d0-38f4-4b51-8c7f-b0267144047f",
        temperatureZ6TowerTopEnvironmentMid: "35aaf68f-9baf-48ef-a172-7e692f8fa383",
        temperatureZ6TowerTopEnvironmentUp: "65c59e85-bb5b-4fcc-9b15-c30ea8302081",
        temperatureZ7TowerMidEnvironmentDown: "5261ff8c-2941-49d8-be8a-987928f776f9",
        temperatureZ7TowerMidEnvironmentMid: "36a87b69-b60a-4393-9d8b-afdde517cc56",
        temperatureZ7TowerMidEnvironmentUp: "c69c9263-c0ff-48b2-9d0c-5096d5d585df",
        temperatureZ7TowerTopEnvironmentDown: "0017764b-c3e0-4456-930c-65b9ef0fde84",
        temperatureZ7TowerTopEnvironmentMid: "73ff750f-39fb-4caa-8abc-b6803e73b8bf",
        temperatureZ7TowerTopEnvironmentUp: "f4b06d47-1489-4885-87ba-178bf89afa62",
        temperatureZ8TowerTopEnvironmentDown: "e322c736-bd01-4796-a3f9-b6c8bb67e80f",
        temperatureZ8TowerTopEnvironmentMid: "f9e9ce6a-4cc2-42a5-9c70-28b92f4f03d3",
        temperatureZ8TowerTopEnvironmentUp: "d2fe859b-95cb-4b26-b1f3-e3591300d0eb",
        temperatureZ8TowerMidEnvironmentUp: "GUID",
        temperatureZ8TowerMidEnvironmentMid: "GUID",
        temperatureZ8TowerMidEnvironmentDown: "GUID",

        temperatureSteelBoxEnvironmentJ1L: "a7fa8bf3-6eb6-4daa-8a86-ec0a13c82728",
        temperatureSteelBoxEnvironmentJ1R: "777fc071-ab03-4526-804a-b8dfbda4ee5e",
        temperatureSteelBoxEnvironmentJ3L: "8fe29a09-1e8c-49c8-be24-a9bb4b23577b",
        temperatureSteelBoxEnvironmentJ3R: "b903675a-1493-4395-aa5a-0331495ff206",
        temperatureSteelBoxEnvironmentNBK1L: "9ddd4a5c-73b8-472f-9844-a8da7df6551b",
        temperatureSteelBoxEnvironmentNBK1R: "453eaf76-b60a-413d-bd19-edddc1a38ab9",
        temperatureSteelBoxEnvironmentSBK1L: "4aaed041-f03d-482c-8bea-bd23ff7a5afc",
        temperatureSteelBoxEnvironmentSBK1R: "97974ede-fa92-4051-990c-c5a0b6aa853f",
        temperatureSteelBoxEnvironmentZ3B11L: "032d4d14-0d29-470d-9b8c-3e12db233256",
        temperatureSteelBoxEnvironmentZ3B11R: "e2dee7f0-cf28-4052-b225-324a8dcee020",
        temperatureSteelBoxEnvironmentZ3B1L: "3da50115-ab99-4caa-91f4-3c297e4ed4ba",
        temperatureSteelBoxEnvironmentZ3B1R: "52b38cec-dc14-4766-81ec-d0f66564be4e",
        temperatureSteelBoxEnvironmentZ3Z11L: "6e99cd9b-8479-4f23-b025-03606c91b16f",
        temperatureSteelBoxEnvironmentZ3Z11R: "517810bb-64ed-4d51-b4e2-e8ea7c7aac3f",
        temperatureSteelBoxEnvironmentZ3Z3L: "69219564-3a03-4099-9c84-9b1e440506af",
        temperatureSteelBoxEnvironmentZ3Z3R: "d9c650ab-1067-460b-8847-ff14beab3856",
        temperatureSteelBoxEnvironmentZ3Z4L: "1a75893b-c360-484b-b44e-10ec035a5c9a",
        temperatureSteelBoxEnvironmentZ3Z4R: "d2f45d5b-ca1b-448a-9656-119e88e4a8a4",
        temperatureSteelBoxEnvironmentZ4B1L: "a1f9fe71-cfdc-420e-ba87-442b1e65a7f8",
        temperatureSteelBoxEnvironmentZ4B1R: "543dce11-02c5-494d-b4be-3b45219bb171",
        temperatureSteelBoxEnvironmentZ4B2L: "0f9b334b-8db2-42ce-a609-20e16acd0043",
        temperatureSteelBoxEnvironmentZ4B2R: "9a0e3de4-e36c-4173-a15f-d0bf869cab7d",
        temperatureSteelBoxEnvironmentZ4B7L: "f8a04af5-33e7-497b-877c-8dbb96f1a365",
        temperatureSteelBoxEnvironmentZ4B7R: "81319906-e3fd-4ab4-a0b6-3a199c92514a",
        temperatureSteelBoxEnvironmentZ4Z12L: "0d0f7d48-aeaf-4ed3-a4a1-a8515ef60631",
        temperatureSteelBoxEnvironmentZ4Z12R: "3c76472d-c4e5-4f38-a90a-9d8dacc8aa87",
        temperatureSteelBoxEnvironmentZ4Z2L: "6ee244d9-aa9c-4edc-b173-6434123d1842",
        temperatureSteelBoxEnvironmentZ4Z2R: "89452e9d-d573-4d91-8a13-b4bf00dd639f",
        temperatureSteelBoxEnvironmentZ5B1L: "725cb1dd-caf8-42eb-8e2d-2df6fd6e2fd2",
        temperatureSteelBoxEnvironmentZ5B1R: "b58d7e12-6405-4bb6-9197-f5ac88316cad",
        temperatureSteelBoxEnvironmentZ5B6L: "7bb568f5-faf1-4e2b-963b-7b9aad5e7987",
        temperatureSteelBoxEnvironmentZ5B6R: "a275bab0-3a05-4c97-b34a-d3677459a314",
        temperatureSteelBoxEnvironmentZ5B7L: "793fe989-5014-4a84-981e-224f3e8e3c87",
        temperatureSteelBoxEnvironmentZ5B7R: "f2fc4081-0908-4238-8069-e44c5dd2fdc7",
        temperatureSteelBoxEnvironmentZ5Z6L: "2cac1213-c403-40be-8b03-10d44751e103",
        temperatureSteelBoxEnvironmentZ5Z6R: "bfb6954f-8aee-4b38-a14b-538ef08e60a8",
        temperatureSteelBoxEnvironmentZ6B12L: "c762117a-b236-4c8d-8334-8025d7166dff",
        temperatureSteelBoxEnvironmentZ6B12R: "ffa7783b-2ad7-432b-967f-eda8f3203569",
        temperatureSteelBoxEnvironmentZ6B1L: "ceb5444a-2beb-419b-a246-d854f98a331b",
        temperatureSteelBoxEnvironmentZ6B1R: "41080f2c-26c6-4c6f-a2ea-00c901769c92",
        temperatureSteelBoxEnvironmentZ6B6L: "38acb8bf-6008-4aa7-8bea-e077fc17283b",
        temperatureSteelBoxEnvironmentZ6B6R: "a7933cd1-e59b-424e-a234-d420827680ee",
        temperatureSteelBoxEnvironmentZ6B7L: "0c41f961-c50b-417c-955f-1f6b602ef401",
        temperatureSteelBoxEnvironmentZ6B7R: "d2471f67-08c5-47e0-b211-63b82e2e7604",
        temperatureSteelBoxEnvironmentZ6Z6L: "cd9652d1-dfa4-4e86-a0a5-919d10666d30",
        temperatureSteelBoxEnvironmentZ6Z6R: "f135775c-83c6-42ee-9a96-5abec869bd0e",
        temperatureSteelBoxEnvironmentZ7B1L: "8a235469-b350-4d10-8533-fae04e682bfe",
        temperatureSteelBoxEnvironmentZ7B1R: "2ead6bd8-3d7c-4a23-b57a-059593a7736d",
        temperatureSteelBoxEnvironmentZ7B2L: "e4a37bef-60d0-465c-82a6-9bf6427a7633",
        temperatureSteelBoxEnvironmentZ7B2R: "37e328ad-5859-4d3e-9c06-52538e7c81af",
        temperatureSteelBoxEnvironmentZ7B7L: "48d2d494-da4e-489a-8d73-b1ad80b0dd80",
        temperatureSteelBoxEnvironmentZ7B7R: "f2c922a9-b3f7-4195-baba-f06825126b84",
        temperatureSteelBoxEnvironmentZ7Z2L: "4e373f64-6628-4089-9938-ab708c6e6217",
        temperatureSteelBoxEnvironmentZ7Z2R: "47e52156-0bd0-45b9-973d-e8d783a1cef9",
        temperatureSteelBoxEnvironmentZ8B11L: "c088e3a2-8390-408c-85b0-bdb249251b21",
        temperatureSteelBoxEnvironmentZ8B11R: "51b76c2b-e6f5-467e-854c-e5568f815445",
        temperatureSteelBoxEnvironmentZ8B1L: "3159a13c-e26a-49bc-a3d7-ba7ba6ac1025",
        temperatureSteelBoxEnvironmentZ8B1R: "99b6b829-9921-4e51-b741-e58399065502",
        temperatureSteelBoxEnvironmentZ8B4L: "9ba200e6-703a-4482-b73d-30b383d62614",
        temperatureSteelBoxEnvironmentZ8B4R: "99c876b2-e65b-452f-bcf0-b15e18a1d494",
        temperatureSteelBoxEnvironmentZ8Z10L: "538cb39d-ff7c-4503-afa6-e05217bef72a",
        temperatureSteelBoxEnvironmentZ8Z10R: "1f8f1fd2-004b-4412-9eb2-b02097f4a6c9",
        temperatureSteelBoxEnvironmentZ8Z3L: "d7ae44f5-1600-4ee8-8b5d-c401617f2101",
        temperatureSteelBoxEnvironmentZ8Z3R: "7f07c111-7907-4305-bb5f-ed35e8b713e6",

        //running
        runningDehumidifierZ3TowerMid: "63874675-fb2b-4485-9e91-b111817ebef3",
        runningDehumidifierZ3TowerTop: "b73b269f-cad4-4d49-9286-68839dbc5699",
        runningDehumidifierZ4TowerMid: "d30b0118-a59b-46a0-afca-0ae7935f0b08",
        runningDehumidifierZ4TowerTop: "b6e90ebb-61d9-474e-91a5-acf423f8f6a1",
        runningDehumidifierZ5TowerMid: "57d5ac79-d2fa-4de2-a9a4-8e22421eb78a",
        runningDehumidifierZ5TowerTop: "330eb75c-0a86-4f03-b274-7a6c72c43aca",
        runningDehumidifierZ6TowerMid: "66f014c4-cb84-4521-91e3-e494793479d7",
        runningDehumidifierZ6TowerTop: "6d63a452-62e5-463c-b0ca-f185d2b67a08",
        runningDehumidifierZ7TowerMid: "037cdc71-ccc7-4558-865a-6b1eb90b4810",
        runningDehumidifierZ7TowerTop: "32bea74c-8b33-46cc-b12a-1aa0aae71ddd",
        runningDehumidifierZ8TowerMid: "GUID",
        runningDehumidifierZ8TowerTop: "0de9399a-b07e-4809-8f14-9d6053db762f",

        runningDehumidifierZ3B5LSteelBoxG1: "b6094068-d879-4b50-be1e-68df028e4db4",
        runningDehumidifierZ3B5RSteelBoxG2: "b155df49-e444-4644-a580-e9038fdb11af",
        runningDehumidifierZ4B11LSteelBoxG3: "4e666598-e770-45bf-b8b4-c5064e87eea7",
        runningDehumidifierZ4B11RSteelBoxG4: "2e9715d6-8c3f-4e3f-982f-c0455b74a865",
        runningDehumidifierZ4Z8RSteelBoxG5: "8caf3155-47a9-48f6-8482-89a16f742d61",
        runningDehumidifierZ4Z8LSteelBoxG6: "fd14830a-4d5d-4432-88b2-0278306a2053",
        runningDehumidifierZ5Z1RSteelBoxG7: "6056ac70-c37d-4280-84d0-1998b16cbf71",
        runningDehumidifierZ5Z1LSteelBoxG8: "161aa44f-04a2-40f8-87b7-6665848737e3",
        runningDehumidifierZ6Z1LSteelBoxG9: "3982ae1a-7afb-4ca9-b3a8-99df28149c83",
        runningDehumidifierZ6Z1RSteelBoxG10: "22bcb17c-96d0-403f-8963-65b7d721ec93",
        runningDehumidifierZ7Z8LSteelBoxG11: "d87aac11-852d-4272-87ec-011afacf1cb1",
        runningDehumidifierZ7Z8RSteelBoxG12: "364e6b70-6463-4e45-8033-a75047d66212",
        runningDehumidifierZ7B11RSteelBoxG13: "dcb770fd-566f-4ce2-865a-190e57eddc9e",
        runningDehumidifierZ7B11LSteelBoxG14: "d2fa2c99-8683-46b2-991f-cfaa29a07b15",
        runningDehumidifierZ8B5RSteelBoxG15: "7964d381-b817-4d58-ae3c-8f03bd974063",
        runningDehumidifierZ8B5LSteelBoxG16: "9ed4188f-c6ab-4335-99a8-baee892b062b",

        //malfunction
        malfunctionDehumidifierZ3TowerMid: "b76e3d1b-17b3-48a1-b5bf-54bba5ed67c1",
        malfunctionDehumidifierZ3TowerTop: "aa67031c-00ab-4dbe-8783-6a2ab43e3744",
        malfunctionDehumidifierZ4TowerMid: "4f36f298-0536-413a-b97e-62866346085f",
        malfunctionDehumidifierZ4TowerTop: "2feedca5-679b-43d5-beb3-1919dee9c69d",
        malfunctionDehumidifierZ5TowerMid: "fe4f9046-7fa1-4b81-9089-bb73909e37b6",
        malfunctionDehumidifierZ5TowerTop: "77c09a14-e132-49d2-b652-0617b7dd4631",
        malfunctionDehumidifierZ6TowerMid: "915f58db-c862-47b7-9c83-ed319f86d3a0",
        malfunctionDehumidifierZ6TowerTop: "a9ca5c3e-9bab-437c-a423-c07dd4496909",
        malfunctionDehumidifierZ7TowerMid: "7a324484-b71e-46c5-bf8f-f34a1ad40c75",
        malfunctionDehumidifierZ7TowerTop: "60758cfc-d499-4fe7-897e-acca0d659fcc",
        malfunctionDehumidifierZ8TowerMid: "GUID",
        malfunctionDehumidifierZ8TowerTop: "31d41712-dec8-4b4c-879d-547cd16750fb",

        malfunctionDehumidifierZ3B5LSteelBoxG1: "c65480ef-4c7d-4b4a-81dc-9b6ccf9a4f94",
        malfunctionDehumidifierZ3B5RSteelBoxG2: "6d8a1df6-575c-4624-b0f8-78033839720f",
        malfunctionDehumidifierZ4B11LSteelBoxG3: "30c31f46-8336-403d-a1ac-6dcee9c5f4b8",
        malfunctionDehumidifierZ4B11RSteelBoxG4: "9eebd884-8226-4424-a0b9-55e2e5f7341c",
        malfunctionDehumidifierZ4Z8RSteelBoxG5: "5d3786eb-6379-4730-85c9-53096f571b9e",
        malfunctionDehumidifierZ4Z8LSteelBoxG6: "211824c7-01e2-453d-8a44-74275323d8e4",
        malfunctionDehumidifierZ5Z1RSteelBoxG7: "5e34ccd8-27fe-4e57-bb87-c09761d390ed",
        malfunctionDehumidifierZ5Z1LSteelBoxG8: "5c6dfba3-3033-4826-98dd-e19543f5d57b",
        malfunctionDehumidifierZ6Z1LSteelBoxG9: "cd17a571-e9f0-4af5-b344-28f68547c111",
        malfunctionDehumidifierZ6Z1RSteelBoxG10: "4d9928dd-18db-4416-bcac-8b3466605088",
        malfunctionDehumidifierZ7Z8LSteelBoxG11: "3e3f42f4-a56a-4362-b13b-58a6ff04e86e",
        malfunctionDehumidifierZ7Z8RSteelBoxG12: "4e3bdde1-90e2-4db9-9ce7-30c88447ab72",
        malfunctionDehumidifierZ7B11RSteelBoxG13: "bf39be53-4f36-447a-9f08-aa49b5d9ff0e",
        malfunctionDehumidifierZ7B11LSteelBoxG14: "2da9b9a2-59e1-4f9f-9cab-3077e4cc7cdc",
        malfunctionDehumidifierZ8B5RSteelBoxG15: "d8140e40-f8a3-4e61-8ff8-df4f9c9ca625",
        malfunctionDehumidifierZ8B5LSteelBoxG16: "a2d0193e-f39f-499d-b97a-c748623c0c09",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {
        humidityAllowedMaxDehumidifierZ3TowerMid: "91ae8484-fa72-4536-bbcf-227485d00984",
        humidityAllowedMaxDehumidifierZ3TowerTop: "a8355f4b-f4f3-4175-bb43-48b6406edf37",
        humidityAllowedMaxDehumidifierZ4TowerMid: "5d116a33-9429-4ea6-9c12-70ca1a3615c9",
        humidityAllowedMaxDehumidifierZ4TowerTop: "1a50053a-6642-4b2f-8485-448ad89d99d0",
        humidityAllowedMaxDehumidifierZ5TowerMid: "e63f2494-2009-431b-b169-d56c178fcc02",
        humidityAllowedMaxDehumidifierZ5TowerTop: "7c6e3109-18ff-4c72-8a86-1bf25ec57260",
        humidityAllowedMaxDehumidifierZ6TowerMid: "7d85ad73-ed97-488f-a041-2a5a6a6be417",
        humidityAllowedMaxDehumidifierZ6TowerTop: "4404eb6b-a447-45cc-8739-9dd6d7b5c1c1",
        humidityAllowedMaxDehumidifierZ7TowerMid: "b1831c64-d258-498a-9323-4fba75f44760",
        humidityAllowedMaxDehumidifierZ7TowerTop: "8635be2d-8dbb-4407-b101-3fc48e399a6c",
        humidityAllowedMaxDehumidifierZ8TowerTop: "6a1c4917-87b6-46fa-8112-d81e787c680a",
        humidityAllowedMaxDehumidifierZ8TowerMid: "GUID",

        humidityAllowedMaxDehumidifierZ3B5LSteelBoxG1: "4c9062f9-8757-41fb-9c7e-715157782742",
        humidityAllowedMaxDehumidifierZ3B5RSteelBoxG2: "9a43d9b9-97b8-48ed-97fa-41345ff6b1ea",
        humidityAllowedMaxDehumidifierZ4B11LSteelBoxG3: "a902c739-631a-49aa-926e-bcba1371c760",
        humidityAllowedMaxDehumidifierZ4B11RSteelBoxG4: "b8684cf4-fa64-426d-bdae-78162cdb8f85",
        humidityAllowedMaxDehumidifierZ4Z8RSteelBoxG5: "0a8340f0-8905-4cee-88e7-590d6ef84f1a",
        humidityAllowedMaxDehumidifierZ4Z8LSteelBoxG6: "986fa3ee-ef35-4793-a76d-4503eb635dd3",
        humidityAllowedMaxDehumidifierZ5Z1RSteelBoxG7: "55872f71-3d07-4804-be6a-c402bc3ac5c9",
        humidityAllowedMaxDehumidifierZ5Z1LSteelBoxG8: "4779cc5d-da22-49be-9eb3-ead0c18fc5f1",
        humidityAllowedMaxDehumidifierZ6Z1LSteelBoxG9: "e311a943-28b9-4b96-bf94-31c803d754fd",
        humidityAllowedMaxDehumidifierZ6Z1RSteelBoxG10: "bd2e5432-bf65-4693-9280-0d77bce2c65c",
        humidityAllowedMaxDehumidifierZ7Z8LSteelBoxG11: "995f666c-4943-4341-b874-5f7e14d9953a",
        humidityAllowedMaxDehumidifierZ7Z8RSteelBoxG12: "a6f2efd7-3a04-45e9-86a6-d42152e2894f",
        humidityAllowedMaxDehumidifierZ7B11RSteelBoxG13: "787bba13-fc52-44ca-9af1-8c6ac492a67d",
        humidityAllowedMaxDehumidifierZ7B11LSteelBoxG14: "122c0972-7f0a-43e1-b5cd-b3b4bd73b9d3",
        humidityAllowedMaxDehumidifierZ8B5RSteelBoxG15: "38cc55e1-1324-4262-ba21-26b599c93612",
        humidityAllowedMaxDehumidifierZ8B5LSteelBoxG16: "61d78ff5-30f1-4bb7-a008-5aeb3a602361",

        humidityAllowedMaxZ3TowerMidEnvironmentDown: "4993762c-ce5b-44db-9373-959bbc19ac88",
        humidityAllowedMaxZ3TowerMidEnvironmentMid: "cf999266-3959-4cc2-a218-3a7e45b244ec",
        humidityAllowedMaxZ3TowerMidEnvironmentUp: "d754da32-51b0-41fb-b5ca-e9a77c991508",
        humidityAllowedMaxZ3TowerTopEnvironmentDown: "3c545c28-09e6-40d9-968b-75c8f92564ee",
        humidityAllowedMaxZ3TowerTopEnvironmentMid: "6d53aec4-a9f6-4575-bfa3-e94f9174c12c",
        humidityAllowedMaxZ3TowerTopEnvironmentUp: "043033cb-8aec-4cd0-8ed6-077e21ecad87",
        humidityAllowedMaxZ4TowerMidEnvironmentDown: "7d62686f-b955-4542-a68f-4531b8e380a9",
        humidityAllowedMaxZ4TowerMidEnvironmentMid: "e46e900c-00d4-4d4e-a1a4-dc0c2fe2be22",
        humidityAllowedMaxZ4TowerMidEnvironmentUp: "21315ac6-9d0d-4b3c-9a11-3562c1e0254c",
        humidityAllowedMaxZ4TowerTopEnvironmentDown: "eb14a35b-d46d-4d09-9ee4-f9b9f2880485",
        humidityAllowedMaxZ4TowerTopEnvironmentMid: "87866948-3674-46ca-b70e-5e6a12d695e3",
        humidityAllowedMaxZ4TowerTopEnvironmentUp: "8a9cebdb-1786-47f2-9f9e-86317cd06132",
        humidityAllowedMaxZ5TowerMidEnvironmentDown: "b56c3ba1-f85d-47c3-8900-ef99eb766838",
        humidityAllowedMaxZ5TowerMidEnvironmentMid: "3947a0d6-3873-449f-ae68-ccf7b9a353a9",
        humidityAllowedMaxZ5TowerMidEnvironmentUp: "8603c4f1-9d24-4f6f-99f7-c80977a28a9e",
        humidityAllowedMaxZ5TowerTopEnvironmentDown: "95322bb5-d441-4efc-a306-0343885a9056",
        humidityAllowedMaxZ5TowerTopEnvironmentMid: "3f19ebed-f8a0-488a-b0ce-21bd639e4fe4",
        humidityAllowedMaxZ5TowerTopEnvironmentUp: "72be3ac0-4b49-46d7-9d0b-cc4e384ccaee",
        humidityAllowedMaxZ6TowerMidEnvironmentDown: "2372aa93-4e8a-4da0-a6a2-a770f1fbc99a",
        humidityAllowedMaxZ6TowerMidEnvironmentMid: "a28e4ba8-e3dc-4262-9ccb-da8a80832708",
        humidityAllowedMaxZ6TowerMidEnvironmentUp: "95b75401-e353-4f3d-94ad-892e0bfca9d9",
        humidityAllowedMaxZ6TowerTopEnvironmentDown: "0f7a5716-23fc-4f23-862e-b705e9efd3ac",
        humidityAllowedMaxZ6TowerTopEnvironmentMid: "950525c9-defe-49fc-a541-026f4b208ed3",
        humidityAllowedMaxZ6TowerTopEnvironmentUp: "3f7acdb7-dd95-454b-9e3a-e7f136fcba70",
        humidityAllowedMaxZ7TowerMidEnvironmentDown: "340161df-96e4-4480-b352-ea7d9c036a7b",
        humidityAllowedMaxZ7TowerMidEnvironmentMid: "5d870b4f-bebf-448b-bce0-4b66c8f9df55",
        humidityAllowedMaxZ7TowerMidEnvironmentUp: "047a3dad-ca1c-48a7-9dc7-9ce32553aa97",
        humidityAllowedMaxZ7TowerTopEnvironmentDown: "a4a44370-0b07-4afc-a73e-3ceb4167d43b",
        humidityAllowedMaxZ7TowerTopEnvironmentMid: "1d64c9bb-31a4-4d6c-9852-e5c67933eff9",
        humidityAllowedMaxZ7TowerTopEnvironmentUp: "ebd0caf6-063a-4391-9a20-b177cf94ff31",
        humidityAllowedMaxZ8TowerTopEnvironmentDown: "7794e86d-98aa-471d-b88c-4d9c945bad38",
        humidityAllowedMaxZ8TowerTopEnvironmentMid: "f7633fec-d517-4abe-9f9d-04c41b748d87",
        humidityAllowedMaxZ8TowerTopEnvironmentUp: "42da9d50-2a83-4014-b9ed-011a1713426a",
        humidityAllowedMaxZ8TowerMidEnvironmentUp: "GUID",
        humidityAllowedMaxZ8TowerMidEnvironmentMid: "GUID",
        humidityAllowedMaxZ8TowerMidEnvironmentDown: "GUID",

        humidityAllowedMaxSteelBoxEnvironmentJ1L: "d757bd03-388b-4cc9-ae60-76a3bd56cb92",
        humidityAllowedMaxSteelBoxEnvironmentJ1R: "630109f2-286d-4543-b08a-4fc156d454d9",
        humidityAllowedMaxSteelBoxEnvironmentJ3L: "1499ddef-148b-4907-97dc-a7a158f06a33",
        humidityAllowedMaxSteelBoxEnvironmentJ3R: "a9cbb9f3-4542-4100-aa11-a828080b40db",
        humidityAllowedMaxSteelBoxEnvironmentNBK1L: "4c9062f9-8757-41fb-9c7e-715157782742",
        humidityAllowedMaxSteelBoxEnvironmentNBK1R: "9a43d9b9-97b8-48ed-97fa-41345ff6b1ea",
        humidityAllowedMaxSteelBoxEnvironmentSBK1L: "7fd56fd6-0c3e-43ae-97db-a9698dacbed2",
        humidityAllowedMaxSteelBoxEnvironmentSBK1R: "4cc57342-b48a-40dd-bc1c-2cb8889b0803",
        humidityAllowedMaxSteelBoxEnvironmentZ3B11L: "5dc7000b-cd2c-459a-9cf5-88cd8d11017b",
        humidityAllowedMaxSteelBoxEnvironmentZ3B11R: "408bb3f4-819c-4a47-8fa4-c9abae496403",
        humidityAllowedMaxSteelBoxEnvironmentZ3B1L: "436b6e6c-9c01-4cff-b6d4-1c13d3e05175",
        humidityAllowedMaxSteelBoxEnvironmentZ3B1R: "f70cf50c-a9c0-4f81-bd92-c60a2e58eb86",
        humidityAllowedMaxSteelBoxEnvironmentZ3Z11L: "6bddf58c-0ba8-45c4-b5fc-a21264f4e609",
        humidityAllowedMaxSteelBoxEnvironmentZ3Z11R: "fbef463a-2bbf-4eb6-be84-6e515249c71e",
        humidityAllowedMaxSteelBoxEnvironmentZ3Z3L: "ef99103d-01e7-42e0-b4c8-e2f05b253f59",
        humidityAllowedMaxSteelBoxEnvironmentZ3Z3R: "da6be5a7-f9f0-4ce3-9b44-83a4854aa1b7",
        humidityAllowedMaxSteelBoxEnvironmentZ3Z4L: "b8684cf4-fa64-426d-bdae-78162cdb8f85",
        humidityAllowedMaxSteelBoxEnvironmentZ3Z4R: "a902c739-631a-49aa-926e-bcba1371c760",
        humidityAllowedMaxSteelBoxEnvironmentZ4B1L: "0a8340f0-8905-4cee-88e7-590d6ef84f1a",
        humidityAllowedMaxSteelBoxEnvironmentZ4B1R: "986fa3ee-ef35-4793-a76d-4503eb635dd3",
        humidityAllowedMaxSteelBoxEnvironmentZ4B2L: "f53739fc-4011-463b-9a07-f47bd7817586",
        humidityAllowedMaxSteelBoxEnvironmentZ4B2R: "e511f1b7-7059-4ea6-b992-7253ba2b2a72",
        humidityAllowedMaxSteelBoxEnvironmentZ4B7L: "7586a52d-da9c-4904-920a-7e7fd3e1cb48",
        humidityAllowedMaxSteelBoxEnvironmentZ4B7R: "1ce2a3e5-ffcf-4334-80c7-29a6e38fc33c",
        humidityAllowedMaxSteelBoxEnvironmentZ4Z12L: "5a2e28f3-939f-447b-bd05-40789b417ed1",
        humidityAllowedMaxSteelBoxEnvironmentZ4Z12R: "5d01db45-b188-4244-951a-1199d8dab3f6",
        humidityAllowedMaxSteelBoxEnvironmentZ4Z2L: "68fe2c60-fe05-4285-b37c-4fa174b925af",
        humidityAllowedMaxSteelBoxEnvironmentZ4Z2R: "7c65f7c8-6e7a-47d9-97d5-6356a8cee0a1",
        humidityAllowedMaxSteelBoxEnvironmentZ5B1L: "e64d8a2c-466b-449f-8223-6a33c9b5a575",
        humidityAllowedMaxSteelBoxEnvironmentZ5B1R: "fa2435d7-64f1-490b-a760-d6c8b3eedf20",
        humidityAllowedMaxSteelBoxEnvironmentZ5B6L: "55872f71-3d07-4804-be6a-c402bc3ac5c9",
        humidityAllowedMaxSteelBoxEnvironmentZ5B6R: "4779cc5d-da22-49be-9eb3-ead0c18fc5f1",
        humidityAllowedMaxSteelBoxEnvironmentZ5B7L: "9bb0c9f3-d2c9-41d6-aa5d-05608a6b82a9",
        humidityAllowedMaxSteelBoxEnvironmentZ5B7R: "1dabce70-5c42-40b3-97c5-50861441e557",
        humidityAllowedMaxSteelBoxEnvironmentZ5Z6L: "e16fbbdf-8851-4aa6-97a1-13e950bb9e78",
        humidityAllowedMaxSteelBoxEnvironmentZ5Z6R: "6dc4690d-dae5-4c4d-9736-ae0654bed4c1",
        humidityAllowedMaxSteelBoxEnvironmentZ6B12L: "5a4d3b75-428b-4853-98bc-46c6bae175e3",
        humidityAllowedMaxSteelBoxEnvironmentZ6B12R: "ebaa11c1-41bb-433f-89c5-e8305b8d037c",
        humidityAllowedMaxSteelBoxEnvironmentZ6B1L: "4ec1deee-eeac-4cb1-8b34-5dd3e203aee2",
        humidityAllowedMaxSteelBoxEnvironmentZ6B1R: "41dbce80-0dbb-494b-8af1-d15a4e5c18da",
        humidityAllowedMaxSteelBoxEnvironmentZ6B6L: "5905ae20-31a1-49f9-b4ac-672d16391ca5",
        humidityAllowedMaxSteelBoxEnvironmentZ6B6R: "150b79ac-f03a-4555-8c0b-3fa7d6f78f6e",
        humidityAllowedMaxSteelBoxEnvironmentZ6B7L: "0149bb1b-eb51-42bb-b192-045454c601b4",
        humidityAllowedMaxSteelBoxEnvironmentZ6B7R: "58a62ade-9a2f-43d0-b241-4f43e8ebb11f",
        humidityAllowedMaxSteelBoxEnvironmentZ6Z6L: "78f8396e-6d38-46e7-83da-3e3ecbd58ed8",
        humidityAllowedMaxSteelBoxEnvironmentZ6Z6R: "c5dd12a3-991f-4b1d-aefd-f95cbd5aec54",
        humidityAllowedMaxSteelBoxEnvironmentZ7B1L: "8bdd38cd-7a70-496c-b90e-21b859a6d1f3",
        humidityAllowedMaxSteelBoxEnvironmentZ7B1R: "e6d8dd94-9585-469d-8c9a-653a2f46dcf3",
        humidityAllowedMaxSteelBoxEnvironmentZ7B2L: "89634b5d-2248-404b-ba90-74ad920f5939",
        humidityAllowedMaxSteelBoxEnvironmentZ7B2R: "adb119c3-d029-4bba-98b4-6f9bf3811a99",
        humidityAllowedMaxSteelBoxEnvironmentZ7B7L: "79920847-5408-4d90-96ee-b81fc46a08b1",
        humidityAllowedMaxSteelBoxEnvironmentZ7B7R: "021da40a-6448-4a76-9817-66dbdda69599",
        humidityAllowedMaxSteelBoxEnvironmentZ7Z2L: "1cb39d0d-5a4d-457b-a6f2-9a0b20c74563",
        humidityAllowedMaxSteelBoxEnvironmentZ7Z2R: "30e51763-7795-4440-a5f3-eb0a56bc1b45",
        humidityAllowedMaxSteelBoxEnvironmentZ8B11L: "c78a0045-c875-42e7-9fdf-db2e0c0016dd",
        humidityAllowedMaxSteelBoxEnvironmentZ8B11R: "6a1e3277-7b9c-4e5f-b12b-cd1dc4e8c2c0",
        humidityAllowedMaxSteelBoxEnvironmentZ8B1L: "a1620726-95af-4f07-8fd4-c6196ccd90b1",
        humidityAllowedMaxSteelBoxEnvironmentZ8B1R: "0bca3ad5-e290-4773-8389-4cdc4f75a362",
        humidityAllowedMaxSteelBoxEnvironmentZ8B4L: "6a879f04-e422-40a8-a66f-36fd82ebcd20",
        humidityAllowedMaxSteelBoxEnvironmentZ8B4R: "6ae4593e-8665-40ae-b873-9a2839aa422e",
        humidityAllowedMaxSteelBoxEnvironmentZ8Z10L: "b031623a-abf1-4987-b0a9-b5a3a268fdea",
        humidityAllowedMaxSteelBoxEnvironmentZ8Z10R: "a919955f-dfd3-4a21-98a5-b5a96db33017",
        humidityAllowedMaxSteelBoxEnvironmentZ8Z3L: "299c2fb6-419a-4ac6-adae-70b41e367243",
        humidityAllowedMaxSteelBoxEnvironmentZ8Z3R: "a0580166-531d-4d4a-b829-5d656f1dae11",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        humidityDehumidifierZ3TowerTop: "errorZ3TowerTop",
        humidityDehumidifierZ3TowerMid: "errorZ3TowerMid",
        humidityDehumidifierZ4TowerTop: "errorZ4TowerTop",
        humidityDehumidifierZ4TowerMid: "errorZ4TowerMid",
        humidityDehumidifierZ5TowerTop: "errorZ5TowerTop",
        humidityDehumidifierZ5TowerMid: "errorZ5TowerMid",
        humidityDehumidifierZ6TowerTop: "errorZ6TowerTop",
        humidityDehumidifierZ6TowerMid: "errorZ6TowerMid",
        humidityDehumidifierZ7TowerTop: "errorZ7TowerTop",
        humidityDehumidifierZ7TowerMid: "errorZ7TowerMid",
        humidityDehumidifierZ8TowerTop: "errorZ8TowerTop",
        humidityDehumidifierZ8TowerMid: "errorZ8TowerMid",

        humidityDehumidifierZ3B5LSteelBoxG1: "errorZ3B5LSteelBoxG1",
        humidityDehumidifierZ3B5RSteelBoxG2: "errorZ3B5RSteelBoxG2",
        humidityDehumidifierZ4B11LSteelBoxG3: "errorZ4B11LSteelBoxG3",
        humidityDehumidifierZ4B11RSteelBoxG4: "errorZ4B11RSteelBoxG4",
        humidityDehumidifierZ4Z8RSteelBoxG5: "errorZ4Z8RSteelBoxG5",
        humidityDehumidifierZ4Z8LSteelBoxG6: "errorZ4Z8LSteelBoxG6",
        humidityDehumidifierZ5Z1RSteelBoxG7: "errorZ5Z1RSteelBoxG7",
        humidityDehumidifierZ5Z1LSteelBoxG8: "errorZ5Z1LSteelBoxG8",
        humidityDehumidifierZ6Z1LSteelBoxG9: "errorZ6Z1LSteelBoxG9",
        humidityDehumidifierZ6Z1RSteelBoxG10: "errorZ6Z1RSteelBoxG10",
        humidityDehumidifierZ7Z8LSteelBoxG11: "errorZ7Z8LSteelBoxG11",
        humidityDehumidifierZ7Z8RSteelBoxG12: "errorZ7Z8RSteelBoxG12",
        humidityDehumidifierZ7B11RSteelBoxG13: "errorZ7B11RSteelBoxG13",
        humidityDehumidifierZ7B11LSteelBoxG14: "errorZ7B11LSteelBoxG14",
        humidityDehumidifierZ8B5RSteelBoxG15: "errorZ8B5RSteelBoxG15",
        humidityDehumidifierZ8B5LSteelBoxG16: "errorZ8B5LSteelBoxG16",

        temperatureDehumidifierZ3TowerTop: "errorZ3TowerTop",
        temperatureDehumidifierZ3TowerMid: "errorZ3TowerMid",
        temperatureDehumidifierZ4TowerTop: "errorZ4TowerTop",
        temperatureDehumidifierZ4TowerMid: "errorZ4TowerMid",
        temperatureDehumidifierZ5TowerTop: "errorZ5TowerTop",
        temperatureDehumidifierZ5TowerMid: "errorZ5TowerMid",
        temperatureDehumidifierZ6TowerTop: "errorZ6TowerTop",
        temperatureDehumidifierZ6TowerMid: "errorZ6TowerMid",
        temperatureDehumidifierZ7TowerTop: "errorZ7TowerTop",
        temperatureDehumidifierZ7TowerMid: "errorZ7TowerMid",
        temperatureDehumidifierZ8TowerTop: "errorZ8TowerTop",
        temperatureDehumidifierZ8TowerMid: "errorZ8TowerMid",

        temperatureDehumidifierZ3B5LSteelBoxG1: "errorZ3B5LSteelBoxG1",
        temperatureDehumidifierZ3B5RSteelBoxG2: "errorZ3B5RSteelBoxG2",
        temperatureDehumidifierZ4B11LSteelBoxG3: "errorZ4B11LSteelBoxG3",
        temperatureDehumidifierZ4B11RSteelBoxG4: "errorZ4B11RSteelBoxG4",
        temperatureDehumidifierZ4Z8RSteelBoxG5: "errorZ4Z8RSteelBoxG5",
        temperatureDehumidifierZ4Z8LSteelBoxG6: "errorZ4Z8LSteelBoxG6",
        temperatureDehumidifierZ5Z1RSteelBoxG7: "errorZ5Z1RSteelBoxG7",
        temperatureDehumidifierZ5Z1LSteelBoxG8: "errorZ5Z1LSteelBoxG8",
        temperatureDehumidifierZ6Z1LSteelBoxG9: "errorZ6Z1LSteelBoxG9",
        temperatureDehumidifierZ6Z1RSteelBoxG10: "errorZ6Z1RSteelBoxG10",
        temperatureDehumidifierZ7Z8LSteelBoxG11: "errorZ7Z8LSteelBoxG11",
        temperatureDehumidifierZ7Z8RSteelBoxG12: "errorZ7Z8RSteelBoxG12",
        temperatureDehumidifierZ7B11RSteelBoxG13: "errorZ7B11RSteelBoxG13",
        temperatureDehumidifierZ7B11LSteelBoxG14: "errorZ7B11LSteelBoxG14",
        temperatureDehumidifierZ8B5RSteelBoxG15: "errorZ8B5RSteelBoxG15",
        temperatureDehumidifierZ8B5LSteelBoxG16: "errorZ8B5LSteelBoxG16",

        humidityZ3TowerTopEnvironmentUp: "errorZ3TowerTop",
        humidityZ3TowerTopEnvironmentMid: "errorZ3TowerTop",
        humidityZ3TowerTopEnvironmentDown: "errorZ3TowerTop",
        humidityZ3TowerMidEnvironmentUp: "errorZ3TowerMid",
        humidityZ3TowerMidEnvironmentMid: "errorZ3TowerMid",
        humidityZ3TowerMidEnvironmentDown: "errorZ3TowerMid",
        humidityZ4TowerTopEnvironmentUp: "errorZ4TowerTop",
        humidityZ4TowerTopEnvironmentMid: "errorZ4TowerTop",
        humidityZ4TowerTopEnvironmentDown: "errorZ4TowerTop",
        humidityZ4TowerMidEnvironmentUp: "errorZ4TowerMid",
        humidityZ4TowerMidEnvironmentMid: "errorZ4TowerMid",
        humidityZ4TowerMidEnvironmentDown: "errorZ4TowerMid",
        humidityZ5TowerTopEnvironmentUp: "errorZ5TowerTop",
        humidityZ5TowerTopEnvironmentMid: "errorZ5TowerTop",
        humidityZ5TowerTopEnvironmentDown: "errorZ5TowerTop",
        humidityZ5TowerMidEnvironmentUp: "errorZ5TowerMid",
        humidityZ5TowerMidEnvironmentMid: "errorZ5TowerMid",
        humidityZ5TowerMidEnvironmentDown: "errorZ5TowerMid",
        humidityZ6TowerTopEnvironmentUp: "errorZ6TowerTop",
        humidityZ6TowerTopEnvironmentMid: "errorZ6TowerTop",
        humidityZ6TowerTopEnvironmentDown: "errorZ6TowerTop",
        humidityZ6TowerMidEnvironmentUp: "errorZ6TowerMid",
        humidityZ6TowerMidEnvironmentMid: "errorZ6TowerMid",
        humidityZ6TowerMidEnvironmentDown: "errorZ6TowerMid",
        humidityZ7TowerTopEnvironmentUp: "errorZ7TowerTop",
        humidityZ7TowerTopEnvironmentMid: "errorZ7TowerTop",
        humidityZ7TowerTopEnvironmentDown: "errorZ7TowerTop",
        humidityZ7TowerMidEnvironmentUp: "errorZ7TowerMid",
        humidityZ7TowerMidEnvironmentMid: "errorZ7TowerMid",
        humidityZ7TowerMidEnvironmentDown: "errorZ7TowerMid",
        humidityZ8TowerTopEnvironmentUp: "errorZ8TowerTop",
        humidityZ8TowerTopEnvironmentMid: "errorZ8TowerTop",
        humidityZ8TowerTopEnvironmentDown: "errorZ8TowerTop",
        humidityZ8TowerMidEnvironmentUp: "errorZ8TowerMid",
        humidityZ8TowerMidEnvironmentMid: "errorZ8TowerMid",
        humidityZ8TowerMidEnvironmentDown: "errorZ8TowerMid",

        humiditySteelBoxEnvironmentZ5B6R: "errorZ5Z1LSteelBoxG8",
        humiditySteelBoxEnvironmentZ5B1R: "errorZ5Z1LSteelBoxG8",
        humiditySteelBoxEnvironmentZ5Z6L: "errorZ5Z1LSteelBoxG8",
        humiditySteelBoxEnvironmentJ3L: "errorZ5Z1LSteelBoxG8",
        humiditySteelBoxEnvironmentZ4B1R: "errorZ4Z8LSteelBoxG6",
        humiditySteelBoxEnvironmentZ4Z2L: "errorZ4Z8LSteelBoxG6",
        humiditySteelBoxEnvironmentZ4Z12L: "errorZ4Z8LSteelBoxG6",
        humiditySteelBoxEnvironmentZ5B7R: "errorZ4Z8LSteelBoxG6",
        humiditySteelBoxEnvironmentZ5B6L: "errorZ5Z1RSteelBoxG7",
        humiditySteelBoxEnvironmentZ5B1L: "errorZ5Z1RSteelBoxG7",
        humiditySteelBoxEnvironmentZ5Z6R: "errorZ5Z1RSteelBoxG7",
        humiditySteelBoxEnvironmentJ3R: "errorZ5Z1RSteelBoxG7",
        humiditySteelBoxEnvironmentNBK1R: "errorZ3B5RSteelBoxG2",
        humiditySteelBoxEnvironmentZ3B11R: "errorZ3B5RSteelBoxG2",
        humiditySteelBoxEnvironmentZ3B1R: "errorZ3B5RSteelBoxG2",
        humiditySteelBoxEnvironmentZ3Z3L: "errorZ3B5RSteelBoxG2",
        humiditySteelBoxEnvironmentZ3Z4R: "errorZ4B11LSteelBoxG3",
        humiditySteelBoxEnvironmentZ3Z11R: "errorZ4B11LSteelBoxG3",
        humiditySteelBoxEnvironmentZ4B7L: "errorZ4B11LSteelBoxG3",
        humiditySteelBoxEnvironmentZ4B2L: "errorZ4B11LSteelBoxG3",
        humiditySteelBoxEnvironmentNBK1L: "errorZ3B5LSteelBoxG1",
        humiditySteelBoxEnvironmentZ3B11L: "errorZ3B5LSteelBoxG1",
        humiditySteelBoxEnvironmentZ3B1L: "errorZ3B5LSteelBoxG1",
        humiditySteelBoxEnvironmentZ3Z3R: "errorZ3B5LSteelBoxG1",
        humiditySteelBoxEnvironmentZ3Z4L: "errorZ4B11RSteelBoxG4",
        humiditySteelBoxEnvironmentZ3Z11L: "errorZ4B11RSteelBoxG4",
        humiditySteelBoxEnvironmentZ4B7R: "errorZ4B11RSteelBoxG4",
        humiditySteelBoxEnvironmentZ4B2R: "errorZ4B11RSteelBoxG4",
        humiditySteelBoxEnvironmentZ4B1L: "errorZ4Z8RSteelBoxG5",
        humiditySteelBoxEnvironmentZ4Z2R: "errorZ4Z8RSteelBoxG5",
        humiditySteelBoxEnvironmentZ4Z12R: "errorZ4Z8RSteelBoxG5",
        humiditySteelBoxEnvironmentZ5B7L: "errorZ4Z8RSteelBoxG5",
        humiditySteelBoxEnvironmentZ8Z3L: "errorZ8B5RSteelBoxG15",
        humiditySteelBoxEnvironmentZ8B1R: "errorZ8B5RSteelBoxG15",
        humiditySteelBoxEnvironmentZ8B11R: "errorZ8B5RSteelBoxG15",
        humiditySteelBoxEnvironmentSBK1R: "errorZ8B5RSteelBoxG15",
        humiditySteelBoxEnvironmentZ8Z3R: "errorZ8B5LSteelBoxG16",
        humiditySteelBoxEnvironmentZ8B1L: "errorZ8B5LSteelBoxG16",
        humiditySteelBoxEnvironmentZ8B11L: "errorZ8B5LSteelBoxG16",
        humiditySteelBoxEnvironmentSBK1L: "errorZ8B5LSteelBoxG16",
        humiditySteelBoxEnvironmentZ6B7R: "errorZ7Z8LSteelBoxG11",
        humiditySteelBoxEnvironmentZ6B12R: "errorZ7Z8LSteelBoxG11",
        humiditySteelBoxEnvironmentZ7Z2L: "errorZ7Z8LSteelBoxG11",
        humiditySteelBoxEnvironmentZ7B1R: "errorZ7Z8LSteelBoxG11",
        humiditySteelBoxEnvironmentZ6B7L: "errorZ7Z8RSteelBoxG12",
        humiditySteelBoxEnvironmentZ6B12L: "errorZ7Z8RSteelBoxG12",
        humiditySteelBoxEnvironmentZ7Z2R: "errorZ7Z8RSteelBoxG12",
        humiditySteelBoxEnvironmentZ7B1L: "errorZ7Z8RSteelBoxG12",
        humiditySteelBoxEnvironmentJ1L: "errorZ6Z1LSteelBoxG9",
        humiditySteelBoxEnvironmentZ6Z6L: "errorZ6Z1LSteelBoxG9",
        humiditySteelBoxEnvironmentZ6B1R: "errorZ6Z1LSteelBoxG9",
        humiditySteelBoxEnvironmentZ6B6R: "errorZ6Z1LSteelBoxG9",
        humiditySteelBoxEnvironmentJ1R: "errorZ6Z1RSteelBoxG10",
        humiditySteelBoxEnvironmentZ6Z6R: "errorZ6Z1RSteelBoxG10",
        humiditySteelBoxEnvironmentZ6B1L: "errorZ6Z1RSteelBoxG10",
        humiditySteelBoxEnvironmentZ6B6L: "errorZ6Z1RSteelBoxG10",
        humiditySteelBoxEnvironmentZ7B2L: "errorZ7B11LSteelBoxG14",
        humiditySteelBoxEnvironmentZ7B7L: "errorZ7B11LSteelBoxG14",
        humiditySteelBoxEnvironmentZ8Z10R: "errorZ7B11LSteelBoxG14",
        humiditySteelBoxEnvironmentZ8B4R: "errorZ7B11LSteelBoxG14",
        humiditySteelBoxEnvironmentZ7B2R: "errorZ7B11RSteelBoxG13",
        humiditySteelBoxEnvironmentZ7B7R: "errorZ7B11RSteelBoxG13",
        humiditySteelBoxEnvironmentZ8Z10L: "errorZ7B11RSteelBoxG13",
        humiditySteelBoxEnvironmentZ8B4L: "errorZ7B11RSteelBoxG13",

        temperatureZ3TowerTopEnvironmentUp: "errorZ3TowerTop",
        temperatureZ3TowerTopEnvironmentMid: "errorZ3TowerTop",
        temperatureZ3TowerTopEnvironmentDown: "errorZ3TowerTop",
        temperatureZ3TowerMidEnvironmentUp: "errorZ3TowerMid",
        temperatureZ3TowerMidEnvironmentMid: "errorZ3TowerMid",
        temperatureZ3TowerMidEnvironmentDown: "errorZ3TowerMid",
        temperatureZ4TowerTopEnvironmentUp: "errorZ4TowerTop",
        temperatureZ4TowerTopEnvironmentMid: "errorZ4TowerTop",
        temperatureZ4TowerTopEnvironmentDown: "errorZ4TowerTop",
        temperatureZ4TowerMidEnvironmentUp: "errorZ4TowerMid",
        temperatureZ4TowerMidEnvironmentMid: "errorZ4TowerMid",
        temperatureZ4TowerMidEnvironmentDown: "errorZ4TowerMid",
        temperatureZ5TowerTopEnvironmentUp: "errorZ5TowerTop",
        temperatureZ5TowerTopEnvironmentMid: "errorZ5TowerTop",
        temperatureZ5TowerTopEnvironmentDown: "errorZ5TowerTop",
        temperatureZ5TowerMidEnvironmentUp: "errorZ5TowerMid",
        temperatureZ5TowerMidEnvironmentMid: "errorZ5TowerMid",
        temperatureZ5TowerMidEnvironmentDown: "errorZ5TowerMid",
        temperatureZ6TowerTopEnvironmentUp: "errorZ6TowerTop",
        temperatureZ6TowerTopEnvironmentMid: "errorZ6TowerTop",
        temperatureZ6TowerTopEnvironmentDown: "errorZ6TowerTop",
        temperatureZ6TowerMidEnvironmentUp: "errorZ6TowerMid",
        temperatureZ6TowerMidEnvironmentMid: "errorZ6TowerMid",
        temperatureZ6TowerMidEnvironmentDown: "errorZ6TowerMid",
        temperatureZ7TowerTopEnvironmentUp: "errorZ7TowerTop",
        temperatureZ7TowerTopEnvironmentMid: "errorZ7TowerTop",
        temperatureZ7TowerTopEnvironmentDown: "errorZ7TowerTop",
        temperatureZ7TowerMidEnvironmentUp: "errorZ7TowerMid",
        temperatureZ7TowerMidEnvironmentMid: "errorZ7TowerMid",
        temperatureZ7TowerMidEnvironmentDown: "errorZ7TowerMid",
        temperatureZ8TowerTopEnvironmentUp: "errorZ8TowerTop",
        temperatureZ8TowerTopEnvironmentMid: "errorZ8TowerTop",
        temperatureZ8TowerTopEnvironmentDown: "errorZ8TowerTop",
        temperatureZ8TowerMidEnvironmentUp: "errorZ8TowerMid",
        temperatureZ8TowerMidEnvironmentMid: "errorZ8TowerMid",
        temperatureZ8TowerMidEnvironmentDown: "errorZ8TowerMid",

        temperatureSteelBoxEnvironmentZ5B6R: "errorZ5Z1LSteelBoxG8",
        temperatureSteelBoxEnvironmentZ5B1R: "errorZ5Z1LSteelBoxG8",
        temperatureSteelBoxEnvironmentZ5Z6L: "errorZ5Z1LSteelBoxG8",
        temperatureSteelBoxEnvironmentJ3L: "errorZ5Z1LSteelBoxG8",
        temperatureSteelBoxEnvironmentZ4B1R: "errorZ4Z8LSteelBoxG6",
        temperatureSteelBoxEnvironmentZ4Z2L: "errorZ4Z8LSteelBoxG6",
        temperatureSteelBoxEnvironmentZ4Z12L: "errorZ4Z8LSteelBoxG6",
        temperatureSteelBoxEnvironmentZ5B7R: "errorZ4Z8LSteelBoxG6",
        temperatureSteelBoxEnvironmentZ5B6L: "errorZ5Z1RSteelBoxG7",
        temperatureSteelBoxEnvironmentZ5B1L: "errorZ5Z1RSteelBoxG7",
        temperatureSteelBoxEnvironmentZ5Z6R: "errorZ5Z1RSteelBoxG7",
        temperatureSteelBoxEnvironmentJ3R: "errorZ5Z1RSteelBoxG7",
        temperatureSteelBoxEnvironmentNBK1R: "errorZ3B5RSteelBoxG2",
        temperatureSteelBoxEnvironmentZ3B11R: "errorZ3B5RSteelBoxG2",
        temperatureSteelBoxEnvironmentZ3B1R: "errorZ3B5RSteelBoxG2",
        temperatureSteelBoxEnvironmentZ3Z3L: "errorZ3B5RSteelBoxG2",
        temperatureSteelBoxEnvironmentZ3Z4R: "errorZ4B11LSteelBoxG3",
        temperatureSteelBoxEnvironmentZ3Z11R: "errorZ4B11LSteelBoxG3",
        temperatureSteelBoxEnvironmentZ4B7L: "errorZ4B11LSteelBoxG3",
        temperatureSteelBoxEnvironmentZ4B2L: "errorZ4B11LSteelBoxG3",
        temperatureSteelBoxEnvironmentNBK1L: "errorZ3B5LSteelBoxG1",
        temperatureSteelBoxEnvironmentZ3B11L: "errorZ3B5LSteelBoxG1",
        temperatureSteelBoxEnvironmentZ3B1L: "errorZ3B5LSteelBoxG1",
        temperatureSteelBoxEnvironmentZ3Z3R: "errorZ3B5LSteelBoxG1",
        temperatureSteelBoxEnvironmentZ3Z4L: "errorZ4B11RSteelBoxG4",
        temperatureSteelBoxEnvironmentZ3Z11L: "errorZ4B11RSteelBoxG4",
        temperatureSteelBoxEnvironmentZ4B7R: "errorZ4B11RSteelBoxG4",
        temperatureSteelBoxEnvironmentZ4B2R: "errorZ4B11RSteelBoxG4",
        temperatureSteelBoxEnvironmentZ4B1L: "errorZ4Z8RSteelBoxG5",
        temperatureSteelBoxEnvironmentZ4Z2R: "errorZ4Z8RSteelBoxG5",
        temperatureSteelBoxEnvironmentZ4Z12R: "errorZ4Z8RSteelBoxG5",
        temperatureSteelBoxEnvironmentZ5B7L: "errorZ4Z8RSteelBoxG5",
        temperatureSteelBoxEnvironmentZ8Z3L: "errorZ8B5RSteelBoxG15",
        temperatureSteelBoxEnvironmentZ8B1R: "errorZ8B5RSteelBoxG15",
        temperatureSteelBoxEnvironmentZ8B11R: "errorZ8B5RSteelBoxG15",
        temperatureSteelBoxEnvironmentSBK1R: "errorZ8B5RSteelBoxG15",
        temperatureSteelBoxEnvironmentZ8Z3R: "errorZ8B5LSteelBoxG16",
        temperatureSteelBoxEnvironmentZ8B1L: "errorZ8B5LSteelBoxG16",
        temperatureSteelBoxEnvironmentZ8B11L: "errorZ8B5LSteelBoxG16",
        temperatureSteelBoxEnvironmentSBK1L: "errorZ8B5LSteelBoxG16",
        temperatureSteelBoxEnvironmentZ6B7R: "errorZ7Z8LSteelBoxG11",
        temperatureSteelBoxEnvironmentZ6B12R: "errorZ7Z8LSteelBoxG11",
        temperatureSteelBoxEnvironmentZ7Z2L: "errorZ7Z8LSteelBoxG11",
        temperatureSteelBoxEnvironmentZ7B1R: "errorZ7Z8LSteelBoxG11",
        temperatureSteelBoxEnvironmentZ6B7L: "errorZ7Z8RSteelBoxG12",
        temperatureSteelBoxEnvironmentZ6B12L: "errorZ7Z8RSteelBoxG12",
        temperatureSteelBoxEnvironmentZ7Z2R: "errorZ7Z8RSteelBoxG12",
        temperatureSteelBoxEnvironmentZ7B1L: "errorZ7Z8RSteelBoxG12",
        temperatureSteelBoxEnvironmentJ1L: "errorZ6Z1LSteelBoxG9",
        temperatureSteelBoxEnvironmentZ6Z6L: "errorZ6Z1LSteelBoxG9",
        temperatureSteelBoxEnvironmentZ6B1R: "errorZ6Z1LSteelBoxG9",
        temperatureSteelBoxEnvironmentZ6B6R: "errorZ6Z1LSteelBoxG9",
        temperatureSteelBoxEnvironmentJ1R: "errorZ6Z1RSteelBoxG10",
        temperatureSteelBoxEnvironmentZ6Z6R: "errorZ6Z1RSteelBoxG10",
        temperatureSteelBoxEnvironmentZ6B1L: "errorZ6Z1RSteelBoxG10",
        temperatureSteelBoxEnvironmentZ6B6L: "errorZ6Z1RSteelBoxG10",
        temperatureSteelBoxEnvironmentZ7B2L: "errorZ7B11LSteelBoxG14",
        temperatureSteelBoxEnvironmentZ7B7L: "errorZ7B11LSteelBoxG14",
        temperatureSteelBoxEnvironmentZ8Z10R: "errorZ7B11LSteelBoxG14",
        temperatureSteelBoxEnvironmentZ8B4R: "errorZ7B11LSteelBoxG14",
        temperatureSteelBoxEnvironmentZ7B2R: "errorZ7B11RSteelBoxG13",
        temperatureSteelBoxEnvironmentZ7B7R: "errorZ7B11RSteelBoxG13",
        temperatureSteelBoxEnvironmentZ8Z10L: "errorZ7B11RSteelBoxG13",
        temperatureSteelBoxEnvironmentZ8B4L: "errorZ7B11RSteelBoxG13",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {
        malfunctionDehumidifierZ3TowerTop: "errorZ3TowerTop",
        malfunctionDehumidifierZ3TowerMid: "errorZ3TowerMid",
        malfunctionDehumidifierZ4TowerTop: "errorZ4TowerTop",
        malfunctionDehumidifierZ4TowerMid: "errorZ4TowerMid",
        malfunctionDehumidifierZ5TowerTop: "errorZ5TowerTop",
        malfunctionDehumidifierZ5TowerMid: "errorZ5TowerMid",
        malfunctionDehumidifierZ6TowerTop: "errorZ6TowerTop",
        malfunctionDehumidifierZ6TowerMid: "errorZ6TowerMid",
        malfunctionDehumidifierZ7TowerTop: "errorZ7TowerTop",
        malfunctionDehumidifierZ7TowerMid: "errorZ7TowerMid",
        malfunctionDehumidifierZ8TowerTop: "errorZ8TowerTop",
        malfunctionDehumidifierZ8TowerMid: "errorZ8TowerMid",

        malfunctionDehumidifierZ3B5LSteelBoxG1: "errorZ3B5LSteelBoxG1",
        malfunctionDehumidifierZ3B5RSteelBoxG2: "errorZ3B5RSteelBoxG2",
        malfunctionDehumidifierZ4B11LSteelBoxG3: "errorZ4B11LSteelBoxG3",
        malfunctionDehumidifierZ4B11RSteelBoxG4: "errorZ4B11RSteelBoxG4",
        malfunctionDehumidifierZ4Z8RSteelBoxG5: "errorZ4Z8RSteelBoxG5",
        malfunctionDehumidifierZ4Z8LSteelBoxG6: "errorZ4Z8LSteelBoxG6",
        malfunctionDehumidifierZ5Z1RSteelBoxG7: "errorZ5Z1RSteelBoxG7",
        malfunctionDehumidifierZ5Z1LSteelBoxG8: "errorZ5Z1LSteelBoxG8",
        malfunctionDehumidifierZ6Z1LSteelBoxG9: "errorZ6Z1LSteelBoxG9",
        malfunctionDehumidifierZ6Z1RSteelBoxG10: "errorZ6Z1RSteelBoxG10",
        malfunctionDehumidifierZ7Z8LSteelBoxG11: "errorZ7Z8LSteelBoxG11",
        malfunctionDehumidifierZ7Z8RSteelBoxG12: "errorZ7Z8RSteelBoxG12",
        malfunctionDehumidifierZ7B11RSteelBoxG13: "errorZ7B11RSteelBoxG13",
        malfunctionDehumidifierZ7B11LSteelBoxG14: "errorZ7B11LSteelBoxG14",
        malfunctionDehumidifierZ8B5RSteelBoxG15: "errorZ8B5RSteelBoxG15",
        malfunctionDehumidifierZ8B5LSteelBoxG16: "errorZ8B5LSteelBoxG16",
      },

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humidityDehumidifierZ3TowerTop: "humidityTooltipErrorDehumidifierZ3TowerTop",
        humidityDehumidifierZ3TowerMid: "humidityTooltipErrorDehumidifierZ3TowerMid",
        humidityDehumidifierZ4TowerTop: "humidityTooltipErrorDehumidifierZ4TowerTop",
        humidityDehumidifierZ4TowerMid: "humidityTooltipErrorDehumidifierZ4TowerMid",
        humidityDehumidifierZ5TowerTop: "humidityTooltipErrorDehumidifierZ5TowerTop",
        humidityDehumidifierZ5TowerMid: "humidityTooltipErrorDehumidifierZ5TowerMid",
        humidityDehumidifierZ6TowerTop: "humidityTooltipErrorDehumidifierZ6TowerTop",
        humidityDehumidifierZ6TowerMid: "humidityTooltipErrorDehumidifierZ6TowerMid",
        humidityDehumidifierZ7TowerTop: "humidityTooltipErrorDehumidifierZ7TowerTop",
        humidityDehumidifierZ7TowerMid: "humidityTooltipErrorDehumidifierZ7TowerMid",
        humidityDehumidifierZ8TowerTop: "humidityTooltipErrorDehumidifierZ8TowerTop",
        humidityDehumidifierZ8TowerMid: "humidityTooltipErrorDehumidifierZ8TowerMid",

        humidityDehumidifierZ3B5LSteelBoxG1: "humidityTooltipErrorDehumidifierZ3B5LSteelBoxG1",
        humidityDehumidifierZ3B5RSteelBoxG2: "humidityTooltipErrorDehumidifierZ3B5RSteelBoxG2",
        humidityDehumidifierZ4B11LSteelBoxG3: "humidityTooltipErrorDehumidifierZ4B11LSteelBoxG3",
        humidityDehumidifierZ4B11RSteelBoxG4: "humidityTooltipErrorDehumidifierZ4B11RSteelBoxG4",
        humidityDehumidifierZ4Z8RSteelBoxG5: "humidityTooltipErrorDehumidifierZ4Z8RSteelBoxG5",
        humidityDehumidifierZ4Z8LSteelBoxG6: "humidityTooltipErrorDehumidifierZ4Z8LSteelBoxG6",
        humidityDehumidifierZ5Z1RSteelBoxG7: "humidityTooltipErrorDehumidifierZ5Z1RSteelBoxG7",
        humidityDehumidifierZ5Z1LSteelBoxG8: "humidityTooltipErrorDehumidifierZ5Z1LSteelBoxG8",
        humidityDehumidifierZ6Z1LSteelBoxG9: "humidityTooltipErrorDehumidifierZ6Z1LSteelBoxG9",
        humidityDehumidifierZ6Z1RSteelBoxG10: "humidityTooltipErrorDehumidifierZ6Z1RSteelBoxG10",
        humidityDehumidifierZ7Z8LSteelBoxG11: "humidityTooltipErrorDehumidifierZ7Z8LSteelBoxG11",
        humidityDehumidifierZ7Z8RSteelBoxG12: "humidityTooltipErrorDehumidifierZ7Z8RSteelBoxG12",
        humidityDehumidifierZ7B11RSteelBoxG13: "humidityTooltipErrorDehumidifierZ7B11RSteelBoxG13",
        humidityDehumidifierZ7B11LSteelBoxG14: "humidityTooltipErrorDehumidifierZ7B11LSteelBoxG14",
        humidityDehumidifierZ8B5RSteelBoxG15: "humidityTooltipErrorDehumidifierZ8B5RSteelBoxG15",
        humidityDehumidifierZ8B5LSteelBoxG16: "humidityTooltipErrorDehumidifierZ8B5LSteelBoxG16",

        humidityZ3TowerTopEnvironmentUp: "humidityTooltipErrorZ3TowerTopEnvironmentUp",
        humidityZ3TowerTopEnvironmentMid: "humidityTooltipErrorZ3TowerTopEnvironmentMid",
        humidityZ3TowerTopEnvironmentDown: "humidityTooltipErrorZ3TowerTopEnvironmentDown",
        humidityZ3TowerMidEnvironmentUp: "humidityTooltipErrorZ3TowerMidEnvironmentUp",
        humidityZ3TowerMidEnvironmentMid: "humidityTooltipErrorZ3TowerMidEnvironmentMid",
        humidityZ3TowerMidEnvironmentDown: "humidityTooltipErrorZ3TowerMidEnvironmentDown",
        humidityZ4TowerTopEnvironmentUp: "humidityTooltipErrorZ4TowerTopEnvironmentUp",
        humidityZ4TowerTopEnvironmentMid: "humidityTooltipErrorZ4TowerTopEnvironmentMid",
        humidityZ4TowerTopEnvironmentDown: "humidityTooltipErrorZ4TowerTopEnvironmentDown",
        humidityZ4TowerMidEnvironmentUp: "humidityTooltipErrorZ4TowerMidEnvironmentUp",
        humidityZ4TowerMidEnvironmentMid: "humidityTooltipErrorZ4TowerMidEnvironmentMid",
        humidityZ4TowerMidEnvironmentDown: "humidityTooltipErrorZ4TowerMidEnvironmentDown",
        humidityZ5TowerTopEnvironmentUp: "humidityTooltipErrorZ5TowerTopEnvironmentUp",
        humidityZ5TowerTopEnvironmentMid: "humidityTooltipErrorZ5TowerTopEnvironmentMid",
        humidityZ5TowerTopEnvironmentDown: "humidityTooltipErrorZ5TowerTopEnvironmentDown",
        humidityZ5TowerMidEnvironmentUp: "humidityTooltipErrorZ5TowerMidEnvironmentUp",
        humidityZ5TowerMidEnvironmentMid: "humidityTooltipErrorZ5TowerMidEnvironmentMid",
        humidityZ5TowerMidEnvironmentDown: "humidityTooltipErrorZ5TowerMidEnvironmentDown",
        humidityZ6TowerTopEnvironmentUp: "humidityTooltipErrorZ6TowerTopEnvironmentUp",
        humidityZ6TowerTopEnvironmentMid: "humidityTooltipErrorZ6TowerTopEnvironmentMid",
        humidityZ6TowerTopEnvironmentDown: "humidityTooltipErrorZ6TowerTopEnvironmentDown",
        humidityZ6TowerMidEnvironmentUp: "humidityTooltipErrorZ6TowerMidEnvironmentUp",
        humidityZ6TowerMidEnvironmentMid: "humidityTooltipErrorZ6TowerMidEnvironmentMid",
        humidityZ6TowerMidEnvironmentDown: "humidityTooltipErrorZ6TowerMidEnvironmentDown",
        humidityZ7TowerTopEnvironmentUp: "humidityTooltipErrorZ7TowerTopEnvironmentUp",
        humidityZ7TowerTopEnvironmentMid: "humidityTooltipErrorZ7TowerTopEnvironmentMid",
        humidityZ7TowerTopEnvironmentDown: "humidityTooltipErrorZ7TowerTopEnvironmentDown",
        humidityZ7TowerMidEnvironmentUp: "humidityTooltipErrorZ7TowerMidEnvironmentUp",
        humidityZ7TowerMidEnvironmentMid: "humidityTooltipErrorZ7TowerMidEnvironmentMid",
        humidityZ7TowerMidEnvironmentDown: "humidityTooltipErrorZ7TowerMidEnvironmentDown",
        humidityZ8TowerTopEnvironmentUp: "humidityTooltipErrorZ8TowerTopEnvironmentUp",
        humidityZ8TowerTopEnvironmentMid: "humidityTooltipErrorZ8TowerTopEnvironmentMid",
        humidityZ8TowerTopEnvironmentDown: "humidityTooltipErrorZ8TowerTopEnvironmentDown",
        humidityZ8TowerMidEnvironmentUp: "humidityTooltipErrorZ8TowerMidEnvironmentUp",
        humidityZ8TowerMidEnvironmentMid: "humidityTooltipErrorZ8TowerMidEnvironmentMid",
        humidityZ8TowerMidEnvironmentDown: "humidityTooltipErrorZ8TowerMidEnvironmentDown",

        humiditySteelBoxEnvironmentZ5B6R: "humidityTooltipErrorSteelBoxEnvironmentZ5B6R",
        humiditySteelBoxEnvironmentZ5B1R: "humidityTooltipErrorSteelBoxEnvironmentZ5B1R",
        humiditySteelBoxEnvironmentZ5Z6L: "humidityTooltipErrorSteelBoxEnvironmentZ5Z6L",
        humiditySteelBoxEnvironmentJ3L: "humidityTooltipErrorSteelBoxEnvironmentJ3L",
        humiditySteelBoxEnvironmentZ4B1R: "humidityTooltipErrorSteelBoxEnvironmentZ4B1R",
        humiditySteelBoxEnvironmentZ4Z2L: "humidityTooltipErrorSteelBoxEnvironmentZ4Z2L",
        humiditySteelBoxEnvironmentZ4Z12L: "humidityTooltipErrorSteelBoxEnvironmentZ4Z12L",
        humiditySteelBoxEnvironmentZ5B7R: "humidityTooltipErrorSteelBoxEnvironmentZ5B7R",
        humiditySteelBoxEnvironmentZ5B6L: "humidityTooltipErrorSteelBoxEnvironmentZ5B6L",
        humiditySteelBoxEnvironmentZ5B1L: "humidityTooltipErrorSteelBoxEnvironmentZ5B1L",
        humiditySteelBoxEnvironmentZ5Z6R: "humidityTooltipErrorSteelBoxEnvironmentZ5Z6R",
        humiditySteelBoxEnvironmentJ3R: "humidityTooltipErrorSteelBoxEnvironmentJ3R",
        humiditySteelBoxEnvironmentNBK1R: "humidityTooltipErrorSteelBoxEnvironmentNBK1R",
        humiditySteelBoxEnvironmentZ3B11R: "humidityTooltipErrorSteelBoxEnvironmentZ3B11R",
        humiditySteelBoxEnvironmentZ3B1R: "humidityTooltipErrorSteelBoxEnvironmentZ3B1R",
        humiditySteelBoxEnvironmentZ3Z3L: "humidityTooltipErrorSteelBoxEnvironmentZ3Z3L",
        humiditySteelBoxEnvironmentZ3Z4R: "humidityTooltipErrorSteelBoxEnvironmentZ3Z4R",
        humiditySteelBoxEnvironmentZ3Z11R: "humidityTooltipErrorSteelBoxEnvironmentZ3Z11R",
        humiditySteelBoxEnvironmentZ4B7L: "humidityTooltipErrorSteelBoxEnvironmentZ4B7L",
        humiditySteelBoxEnvironmentZ4B2L: "humidityTooltipErrorSteelBoxEnvironmentZ4B2L",
        humiditySteelBoxEnvironmentNBK1L: "humidityTooltipErrorSteelBoxEnvironmentNBK1L",
        humiditySteelBoxEnvironmentZ3B11L: "humidityTooltipErrorSteelBoxEnvironmentZ3B11L",
        humiditySteelBoxEnvironmentZ3B1L: "humidityTooltipErrorSteelBoxEnvironmentZ3B1L",
        humiditySteelBoxEnvironmentZ3Z3R: "humidityTooltipErrorSteelBoxEnvironmentZ3Z3R",
        humiditySteelBoxEnvironmentZ3Z4L: "humidityTooltipErrorSteelBoxEnvironmentZ3Z4L",
        humiditySteelBoxEnvironmentZ3Z11L: "humidityTooltipErrorSteelBoxEnvironmentZ3Z11L",
        humiditySteelBoxEnvironmentZ4B7R: "humidityTooltipErrorSteelBoxEnvironmentZ4B7R",
        humiditySteelBoxEnvironmentZ4B2R: "humidityTooltipErrorSteelBoxEnvironmentZ4B2R",
        humiditySteelBoxEnvironmentZ4B1L: "humidityTooltipErrorSteelBoxEnvironmentZ4B1L",
        humiditySteelBoxEnvironmentZ4Z2R: "humidityTooltipErrorSteelBoxEnvironmentZ4Z2R",
        humiditySteelBoxEnvironmentZ4Z12R: "humidityTooltipErrorSteelBoxEnvironmentZ4Z12R",
        humiditySteelBoxEnvironmentZ5B7L: "humidityTooltipErrorSteelBoxEnvironmentZ5B7L",
        humiditySteelBoxEnvironmentZ8Z3L: "humidityTooltipErrorSteelBoxEnvironmentZ8Z3L",
        humiditySteelBoxEnvironmentZ8B1R: "humidityTooltipErrorSteelBoxEnvironmentZ8B1R",
        humiditySteelBoxEnvironmentZ8B11R: "humidityTooltipErrorSteelBoxEnvironmentZ8B11R",
        humiditySteelBoxEnvironmentSBK1R: "humidityTooltipErrorSteelBoxEnvironmentSBK1R",
        humiditySteelBoxEnvironmentZ8Z3R: "humidityTooltipErrorSteelBoxEnvironmentZ8Z3R",
        humiditySteelBoxEnvironmentZ8B1L: "humidityTooltipErrorSteelBoxEnvironmentZ8B1L",
        humiditySteelBoxEnvironmentZ8B11L: "humidityTooltipErrorSteelBoxEnvironmentZ8B11L",
        humiditySteelBoxEnvironmentSBK1L: "humidityTooltipErrorSteelBoxEnvironmentSBK1L",
        humiditySteelBoxEnvironmentZ6B7R: "humidityTooltipErrorSteelBoxEnvironmentZ6B7R",
        humiditySteelBoxEnvironmentZ6B12R: "humidityTooltipErrorSteelBoxEnvironmentZ6B12R",
        humiditySteelBoxEnvironmentZ7Z2L: "humidityTooltipErrorSteelBoxEnvironmentZ7Z2L",
        humiditySteelBoxEnvironmentZ7B1R: "humidityTooltipErrorSteelBoxEnvironmentZ7B1R",
        humiditySteelBoxEnvironmentZ6B7L: "humidityTooltipErrorSteelBoxEnvironmentZ6B7L",
        humiditySteelBoxEnvironmentZ6B12L: "humidityTooltipErrorSteelBoxEnvironmentZ6B12L",
        humiditySteelBoxEnvironmentZ7Z2R: "humidityTooltipErrorSteelBoxEnvironmentZ7Z2R",
        humiditySteelBoxEnvironmentZ7B1L: "humidityTooltipErrorSteelBoxEnvironmentZ7B1L",
        humiditySteelBoxEnvironmentJ1L: "humidityTooltipErrorSteelBoxEnvironmentJ1L",
        humiditySteelBoxEnvironmentZ6Z6L: "humidityTooltipErrorSteelBoxEnvironmentZ6Z6L",
        humiditySteelBoxEnvironmentZ6B1R: "humidityTooltipErrorSteelBoxEnvironmentZ6B1R",
        humiditySteelBoxEnvironmentZ6B6R: "humidityTooltipErrorSteelBoxEnvironmentZ6B6R",
        humiditySteelBoxEnvironmentJ1R: "humidityTooltipErrorSteelBoxEnvironmentJ1R",
        humiditySteelBoxEnvironmentZ6Z6R: "humidityTooltipErrorSteelBoxEnvironmentZ6Z6R",
        humiditySteelBoxEnvironmentZ6B1L: "humidityTooltipErrorSteelBoxEnvironmentZ6B1L",
        humiditySteelBoxEnvironmentZ6B6L: "humidityTooltipErrorSteelBoxEnvironmentZ6B6L",
        humiditySteelBoxEnvironmentZ7B2L: "humidityTooltipErrorSteelBoxEnvironmentZ7B2L",
        humiditySteelBoxEnvironmentZ7B7L: "humidityTooltipErrorSteelBoxEnvironmentZ7B7L",
        humiditySteelBoxEnvironmentZ8Z10R: "humidityTooltipErrorSteelBoxEnvironmentZ8Z10R",
        humiditySteelBoxEnvironmentZ8B4R: "humidityTooltipErrorSteelBoxEnvironmentZ8B4R",
        humiditySteelBoxEnvironmentZ7B2R: "humidityTooltipErrorSteelBoxEnvironmentZ7B2R",
        humiditySteelBoxEnvironmentZ7B7R: "humidityTooltipErrorSteelBoxEnvironmentZ7B7R",
        humiditySteelBoxEnvironmentZ8Z10L: "humidityTooltipErrorSteelBoxEnvironmentZ8Z10L",
        humiditySteelBoxEnvironmentZ8B4L: "humidityTooltipErrorSteelBoxEnvironmentZ8B4L",
      },

      //running -> running class
      dataNameRunningClassNameDict: {
        runningDehumidifierZ3TowerTop: "runningClassZ3TowerTop",
        runningDehumidifierZ3TowerMid: "runningClassZ3TowerMid",
        runningDehumidifierZ4TowerTop: "runningClassZ4TowerTop",
        runningDehumidifierZ4TowerMid: "runningClassZ4TowerMid",
        runningDehumidifierZ5TowerTop: "runningClassZ5TowerTop",
        runningDehumidifierZ5TowerMid: "runningClassZ5TowerMid",
        runningDehumidifierZ6TowerTop: "runningClassZ6TowerTop",
        runningDehumidifierZ6TowerMid: "runningClassZ6TowerMid",
        runningDehumidifierZ7TowerTop: "runningClassZ7TowerTop",
        runningDehumidifierZ7TowerMid: "runningClassZ7TowerMid",
        runningDehumidifierZ8TowerTop: "runningClassZ8TowerTop",
        runningDehumidifierZ8TowerMid: "runningClassZ8TowerMid",

        runningDehumidifierZ3B5LSteelBoxG1: "runningClassZ3B5LSteelBoxG1",
        runningDehumidifierZ3B5RSteelBoxG2: "runningClassZ3B5RSteelBoxG2",
        runningDehumidifierZ4B11LSteelBoxG3: "runningClassZ4B11LSteelBoxG3",
        runningDehumidifierZ4B11RSteelBoxG4: "runningClassZ4B11RSteelBoxG4",
        runningDehumidifierZ4Z8RSteelBoxG5: "runningClassZ4Z8RSteelBoxG5",
        runningDehumidifierZ4Z8LSteelBoxG6: "runningClassZ4Z8LSteelBoxG6",
        runningDehumidifierZ5Z1RSteelBoxG7: "runningClassZ5Z1RSteelBoxG7",
        runningDehumidifierZ5Z1LSteelBoxG8: "runningClassZ5Z1LSteelBoxG8",
        runningDehumidifierZ6Z1LSteelBoxG9: "runningClassZ6Z1LSteelBoxG9",
        runningDehumidifierZ6Z1RSteelBoxG10: "runningClassZ6Z1RSteelBoxG10",
        runningDehumidifierZ7Z8LSteelBoxG11: "runningClassZ7Z8LSteelBoxG11",
        runningDehumidifierZ7Z8RSteelBoxG12: "runningClassZ7Z8RSteelBoxG12",
        runningDehumidifierZ7B11RSteelBoxG13: "runningClassZ7B11RSteelBoxG13",
        runningDehumidifierZ7B11LSteelBoxG14: "runningClassZ7B11LSteelBoxG14",
        runningDehumidifierZ8B5RSteelBoxG15: "runningClassZ8B5RSteelBoxG15",
        runningDehumidifierZ8B5LSteelBoxG16: "runningClassZ8B5LSteelBoxG16",
      },

      //station id list
      stationIdList: [
        "526a9fc3-a431-4721-8d65-3fbd4768ce97",
        "5163142e-6387-4576-8897-b8a7c84c6b2d",
        "cbb10f86-839b-43c2-9862-9b53ba14af83",
        "f2215d1c-67e0-4933-8d94-3b3e3dd25416",
        "fa256e35-a1a0-4707-87b6-340349a6d57e",
        "d49031ad-5cc2-4a87-9949-085d7561f558",
        "f6fd795d-9997-41fb-9235-9a13c4b7b3b3",
        "866c8eab-a7cb-41ef-8d00-bce2a0765039",
        "18aaceb1-5a99-48ab-a611-6cdc24a9e7d8",
        "bb7d3e27-16e0-4bac-b03e-80fb3fbbb677",
        "b0f253da-7e5d-498c-ac70-7f734fea7211",
        "6bdccb35-6496-4e88-a7fd-88bd68886ba1",
        "04687cf0-2a38-435a-8450-4cfad633ea3c",
        "c0c06689-dba3-4ea9-8882-466d23934617",
        "4b5cbc68-481a-4c54-bba1-8e8dd95636ad",
        "36ac8512-9e39-4500-b1ea-dab333264883",
      ],

      stationNameStationIdDict: {
        "stationG8": "526a9fc3-a431-4721-8d65-3fbd4768ce97",
        "stationG13": "5163142e-6387-4576-8897-b8a7c84c6b2d",
        "stationG6": "cbb10f86-839b-43c2-9862-9b53ba14af83",
        "stationG16": "f2215d1c-67e0-4933-8d94-3b3e3dd25416",
        "stationG7": "fa256e35-a1a0-4707-87b6-340349a6d57e",
        "stationG2": "d49031ad-5cc2-4a87-9949-085d7561f558",
        "stationG4": "f6fd795d-9997-41fb-9235-9a13c4b7b3b3",
        "stationG1": "866c8eab-a7cb-41ef-8d00-bce2a0765039",
        "stationG3": "18aaceb1-5a99-48ab-a611-6cdc24a9e7d8",
        "stationG5": "bb7d3e27-16e0-4bac-b03e-80fb3fbbb677",
        "stationG12": "b0f253da-7e5d-498c-ac70-7f734fea7211",
        "stationG10": "6bdccb35-6496-4e88-a7fd-88bd68886ba1",
        "stationG15": "04687cf0-2a38-435a-8450-4cfad633ea3c",
        "stationG11": "c0c06689-dba3-4ea9-8882-466d23934617",
        "stationG9": "4b5cbc68-481a-4c54-bba1-8e8dd95636ad",
        "stationG14": "36ac8512-9e39-4500-b1ea-dab333264883",
      },

      stationNameLoadingDict: {
        "stationG8": false,
        "stationG13": false,
        "stationG6": false,
        "stationG16": false,
        "stationG7": false,
        "stationG2": false,
        "stationG4": false,
        "stationG1": false,
        "stationG3": false,
        "stationG5": false,
        "stationG12": false,
        "stationG10": false,
        "stationG15": false,
        "stationG11": false,
        "stationG9": false,
        "stationG14": false,
      },
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      this.loading = true;
      // let stationRequestList = [];
      // this.stationIdList.forEach((stationId) => {
      //   stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      // });

      // this.$http.all(stationRequestList).then(
      //   this.$http.spread((...resList) => {
      //     resList.forEach((res) => {
      //       this.setDataAndError(res.data);
      //       this.loading = false;
      //     });
      //   })
      // );

      for (let stationName in this.stationNameLoadingDict) {
        this.stationNameLoadingDict[stationName] = true;
      }

      this.$nextTick(() => {
        for (let stationName in this.stationNameStationIdDict) {
          this.getDataForStation(stationName);
        }

        setTimeout(() => {
          this.loading = false;
        }, 500);

      })


    },
    getDataForStation(stationName) {
      let stationId = this.stationNameStationIdDict[stationName];
      if (!stationId) {
        return;
      }

      this.stationNameLoadingDict[stationName] = true;
      this.$http.get('/deviceData/Station?stationId=' + stationId).then((res) => {
        this.setDataAndError(res.data);
        this.stationNameLoadingDict[stationName] = false;
      })
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          console.log(dataName + ": " + this.dataNameErrorNameDict[dataName]);

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];

            if (errorName === "errorZ6Z1LSteelBoxG9") {
              console.log(errorName + ": " + this[errorName] + ", " + stationData[dataId].errorLevel);
            }

            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }

      // console.log("error g1: " + this.errorZ3B5LSteelBoxG1);
      // console.log("error g9: " + this.errorZ6Z1LSteelBoxG9);
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel.toLowerCase() !== "warning") {
        if (runningFlag > 0) {
          result += ", 除湿机运行";
        } else if (runningFlag === 0) {
          result += ", 除湿机停止";
        }
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
    hrefToScenario(id) {
      if (!id || id === "") {
        return;
      }

      this.$router.push("/" + this.routerPrefix + "/dataHistory?bridgeId=" + this.bridgeId + "&scenarioId=" + id);
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }

  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}

@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }

  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: bold;
        font-size: 32px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;

        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;

          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }

        .sensor1:after {
          background: #c7798b;
        }

        .sensor2:after {
          background: #3376c7;
        }
      }

      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;

        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;

          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }

        .default:after {
          background: #ffff00;
        }

        .running:after {
          background: #67dd34;
        }

        .stopped:after {
          background: #a0a0a0;
        }
      }

      .legend-station {
        position: absolute;
        left: 73px;
        top: 108px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }

        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;

        i {
          font-size: 30px;
        }

        .dir-text {
          font-size: 20px;
        }
      }

      .left-dir {
        left: 185px;
      }

      .right-dir {
        flex-direction: row-reverse;
        right: 185px;
      }

      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/jiashao/bridgeLine2.png");
        background-position-y: 100%;

        &.image-reversed {
          background-image: url("../../assets/image/jiashao/bridgeLineReversed2.png");
        }

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .tower-name {
          border-radius: 50%;
          color: #344084;
          font-weight: bold;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 3px solid;
          width: 24px;
          height: 24px;
          padding-left: 1px;

          &.tower-name-z3 {
            position: absolute;
            top: 232px;
            left: 264px;
          }

          &.tower-name-z4 {
            position: absolute;
            top: 234px;
            left: 620px;
          }

          &.tower-name-z5 {
            position: absolute;
            top: 234px;
            left: 975px;
          }

          &.tower-name-z6 {
            position: absolute;
            top: 234px;
            left: 184px;
          }

          &.tower-name-z7 {
            position: absolute;
            top: 234px;
            left: 540px;
          }

          &.tower-name-z8 {
            position: absolute;
            top: 232px;
            left: 895px;
          }
        }

        .stati {
          position: absolute;

          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }

          &:before {
            width: 50px;
          }

          &:after {
            width: 15px;
          }

          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);

            &:before {
              background-color: #ed6a5a;
            }

            &>p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;

              &:first-child {
                font-size: 13px;
              }
            }

            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }

            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }

            &.bottom-pos:before {
              left: 50%;
              top: 96%;
              transform: translate(0%, 0%);
            }

            &.top-pos:before {
              left: 50%;
              top: -3px;
              transform: translate(0%, 0%);
            }

            &.bottom-pos-sta:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }

            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .bold {
              font-weight: 800;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }

              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }

          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }

          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;

          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }

          &:before {
            width: 50px;
          }

          &:after {
            width: 15px;
          }

          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

            &>p {
              margin: 0;
              white-space: nowrap;

              &:first-child {
                font-size: 13px;
              }
            }

            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }

            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }

            &.bottom-pos:before {
              left: 50%;
              top: 90%;
              transform: translate(0%, 0%);
            }

            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }

          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }

          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }

          &.sensor1 {
            background: #c7798b;

            &:after,
            &:before {
              background: #c7798b;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #c7798b;
              }
            }
          }

          &.sensor2 {
            background: #3376c7;

            &:after,
            &:before {
              background: #3376c7;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .station-block-g1g2 {
          top: 162px;
          left: 185px;
        }

        .station-block-g3g4 {
          top: 162px;
          left: 470px;
        }

        .station-block-g5g6 {
          top: 162px;
          left: 745px;
        }

        .station-block-g7g8 {
          top: 162px;
          left: 1012px;
        }

        .station-block-g9g10 {
          top: 162px;
          left: 155px;
        }

        .station-block-g11g12 {
          top: 162px;
          left: 430px;
        }

        .station-block-g13g14 {
          top: 162px;
          left: 700px;
        }

        .station-block-g15g16 {
          top: 162px;
          left: 980px;
        }

        .sta-g1 {
          top: 186px;
          left: 70px;

          &::before {
            bottom: 42px;
            left: 79px;
            width: 80px;
            transform: rotate(75deg);
          }

          &::after {
            bottom: 80px;
            left: 79px;
            width: 30px;
          }

          .state-info {
            right: -85px;
            top: -80px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 190px;
          }
        }

        .sta-g2 {
          top: 186px;
          left: 68px;

          &::before {
            bottom: -25px;
            left: 86px;
            width: 65px;
            transform: rotate(285deg);
          }

          &::after {
            bottom: -56px;
            left: 81px;
            width: 30px;
          }

          .state-info {
            right: -85px;
            top: 55px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 190px;
          }
        }

        .sta-g3 {
          top: 186px;
          left: 355px;

          &::before {
            bottom: 34px;
            left: 97px;
            width: 60px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -218px;
            top: -100px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 190px;
          }
        }

        .sta-g4 {
          top: 186px;
          left: 355px;

          &::before {
            bottom: 0px;
            left: 117px;
            width: 20px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -218px;
            top: 65px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 190px;
          }
        }

        .sta-g5 {
          top: 186px;
          left: 630px;

          &::before {
            bottom: 34px;
            left: 97px;
            width: 60px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -218px;
            top: -100px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 190px;
          }
        }

        .sta-g6 {
          top: 186px;
          left: 630px;

          &::before {
            bottom: 0px;
            left: 117px;
            width: 20px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -218px;
            top: 65px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 190px;
          }
        }

        .sta-g7 {
          top: 186px;
          left: 897px;

          &::before {
            bottom: 42px;
            left: 95px;
            width: 80px;
            transform: rotate(105deg);
          }

          &::after {
            bottom: 80px;
            left: 145px;
            width: 30px;
          }

          .state-info {
            right: -360px;
            top: -80px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 190px;
          }
        }

        .sta-g8 {
          top: 186px;
          left: 897px;

          &::before {
            bottom: -25px;
            left: 102px;
            width: 65px;
            transform: rotate(255deg);
          }

          &::after {
            bottom: -56px;
            left: 143px;
            width: 30px;
          }

          .state-info {
            right: -360px;
            top: 55px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 190px;
          }
        }

        .sta-g9 {
          top: 186px;
          left: 40px;

          &::before {
            bottom: 42px;
            left: 79px;
            width: 80px;
            transform: rotate(75deg);
          }

          &::after {
            bottom: 80px;
            left: 79px;
            width: 30px;
          }

          .state-info {
            right: -85px;
            top: -80px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 190px;
          }
        }

        .sta-g10 {
          top: 186px;
          left: 38px;

          &::before {
            bottom: -25px;
            left: 86px;
            width: 65px;
            transform: rotate(285deg);
          }

          &::after {
            bottom: -56px;
            left: 81px;
            width: 30px;
          }

          .state-info {
            right: -85px;
            top: 55px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 190px;
          }
        }

        .sta-g11 {
          top: 186px;
          left: 315px;

          &::before {
            bottom: 34px;
            left: 97px;
            width: 60px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -218px;
            top: -100px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 190px;
          }
        }

        .sta-g12 {
          top: 186px;
          left: 315px;

          &::before {
            bottom: 0px;
            left: 117px;
            width: 20px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -218px;
            top: 65px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 190px;
          }
        }

        .sta-g13 {
          top: 186px;
          left: 585px;

          &::before {
            bottom: 34px;
            left: 97px;
            width: 60px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -218px;
            top: -100px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 190px;
          }
        }

        .sta-g14 {
          top: 186px;
          left: 585px;

          &::before {
            bottom: 0px;
            left: 117px;
            width: 20px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -218px;
            top: 65px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 190px;
          }
        }

        .sta-g15 {
          top: 186px;
          left: 864px;

          &::before {
            bottom: 42px;
            left: 95px;
            width: 80px;
            transform: rotate(105deg);
          }

          &::after {
            bottom: 80px;
            left: 145px;
            width: 30px;
          }

          .state-info {
            right: -360px;
            top: -80px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 190px;
          }
        }

        .sta-g16 {
          top: 186px;
          left: 864px;

          &::before {
            bottom: -25px;
            left: 102px;
            width: 65px;
            transform: rotate(255deg);
          }

          &::after {
            bottom: -56px;
            left: 143px;
            width: 30px;
          }

          .state-info {
            right: -360px;
            top: 55px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 190px;
          }
        }
      }
    }
  }
}
</style>